/* eslint-disable  */
// @ts-ignore
import {
  Box,
  Button,
  Flex,
  SimpleGrid,
  Icon,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  Image,
  useColorModeValue,
  Select,
  FormLabel,
  Divider,
  IconButton,
  Checkbox,
  Grid,
  Link,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  GridItem,
  Th,
  Table,
  Thead,
  Tbody,
  Tr,
  Td,
  TableContainer,
  Radio,
  RadioGroup,
  Avatar,
  Tooltip,
  CircularProgress,
} from "@chakra-ui/react";
import "assets/css/App.css";
import DatePicker from "react-date-picker";
import { AsyncSelect, OptionBase, GroupBase } from "chakra-react-select";
import {
  maskCpfCnpj,
  maskCep,
  ufSelect,
  maskCelular,
  IsEmpty,
  IsNotEmpty,
  maskOnlyNumbers,
  maskData,
  isEmail,
  IsCPF,
  downloadPDF,
  maskDataHistorico,
  maskDataHistoricoSemHora,
  convertData,
  maskDatainfor,
  maskDataInfo,
  isDateStringValid,
  maskSemPontos,
  formatCurrencyFloor,
  formatDataTimeStamp,
  validaCnsProv,
  menor12Anos,
  maskCaracterEspecial,
  formatarNomeCompleto,
  maskDataLaudoImpressao,
  menor18Anos,
  isAbleToGiveGratuidade
} from "config/functions";
import InfiniteScroll from "react-infinite-scroll-component";
import { pt } from "date-fns/locale";
import {
  MdCancelPresentation,
  MdDateRange,
  MdSearch,
  MdStore,
  MdCreditCardOff,
  MdCreditCard,
  MdOutlineClose,
  MdCompareArrows,
  MdError,
  MdOutlineCreditCard,
  MdOutlineQrCode,
  MdNfc,
  MdCheckCircle,
  MdContactSupport,
  MdOutlinePersonAddAlt1,
  MdFingerprint,
} from "react-icons/md";
import { Dropzone, FileItem, FullScreenPreview } from "@dropzone-ui/react";
//--------------ZENDESK------------------------
import { MultiValue } from "react-select";
import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from "react-router-dom";
import { AuthContext } from "contexts/requiredAuth";
import "assets/css/DatePickerInput.css";
import "assets/css/SelectAsync.css";

import Information from "views/admin/atendimento/profile/components/Information";
import { ClientePessoaFisica } from "views/admin/atendimento/profile/components/Cliente";

// Custom components
import { CircProgressMini } from "components/charts/CircularProgress";
import TextField from "components/fields/TextField";
import OrderStep from "components/dataDisplay/OrderStep";
import IconBox from "components/icons/IconBox";
import OrderStatus from "components/orderStatus";
import Card from "components/card/Card";
import InputField from "components/fields/InputField";
import PopOverAlert from "components/popAlert/popAlert";
import Camera from "components/camera/Camera";
import HistoricoTickets from "components/HistoricoTickets/HistoticoTickets";
import Profile from "components/Profile/Profile";

// Assets
import {
  MdFlag,
  MdCheck,
  MdOutlineClear,
  MdYoutubeSearchedFor,
  MdOutlineDoubleArrow,
  MdOutlineEngineering,
  MdHome,
  MdPrint,
  Md10K,
} from "react-icons/md";
import { IoSearch, IoCloseCircle } from "react-icons/io5";
import { DateRangePicker } from "react-date-range";
import {
  pesquisaCliente,
  cadastraCliente,
  docsObrigatorios,
  editaGratuidade,
  enviaEmailAtendimento,
  cadastrarProtocolo,
  buscaCep,
  alteraClienteAtendimento2,
  alteraClienteAtendimento,
  listarUnidadesUap,
  listarCids,
  consultaDadosMedicosPCD,
  cadastrarDadosMedicos,
  alterarDadosMedicos,
  salvarLaudo,
  buscarLaudo,
  alterarLaudo,
  buscarLojasNaAPI,
  buscar2Via,
  buscarHistoricoPedidoCartao,
  finalizarPedidoCartao,
  consultarGratuidadePcd,
  alterarProtocolo,
  salvaRegras,
  checkUserDoc,
  getOperadoras,
} from "config/apis/requests";
import { set } from "date-fns";
import { number } from "yargs";
import {
  Page,
  View,
  Document,
  StyleSheet,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import saudePng from "assets/img/logo-saude.png";
import { isEmpty } from "@chakra-ui/utils";
import { isNull } from "lodash";

export default function Pcd() {
  const idTipoGratuidade = 3; // PCD
  const { push } = useHistory();
  const { logout } = useContext(AuthContext);
  const iconColor = useColorModeValue("brand.500", "white");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const bgBar = useColorModeValue("secondaryGray.100", "whiteAlpha.100");
  const textColorTertiary = useColorModeValue("secondaryGray.600", "white");
  const textColorSecondary = "secondaryGray.600";
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const [listaDeLojas, setListaDeLojas] = useState([]);
  const [isentoBiometria, setIsentoBiometria] = useState(false);
  const [codigoLojaSelecionada, setCodigoLojaSelecionada] = useState(0);
  const [lojaSelecionada, setLojaSelecionada] = useState("0");
  const [ondeReceber, setOndeReceber] = useState("loja");
  const [activeBullets, setActiveBullets] = useState({
    form: true,
    rules: false,
    regras: false,
    media: false,
    cartao: false,
    validation: false,
  });
  let resolvedDataCids: any[] = [];
  const [hasMore, setHasMore] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [pagina, setPagina] = useState(1);
  const [modalData, setModalData] = useState(false);
  const [value, setValue] = useState("1"); // Estado para armazenar o valor selecionado

  const formTab = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const rulesTab = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const regrasTab = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const mediaTab = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const cartaoTab = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const validationTab =
    React.useRef() as React.MutableRefObject<HTMLInputElement>;
  let cliente = new ClientePessoaFisica();
  const printRef = useRef<HTMLDivElement>(null);
  const [showForm, setShowForm] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isCancelOpen, setIsCancelOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [titlePopOver, setTitlePopOver] = useState("Ops...");
  const [subtitlePopOver, setSubtitlePopOver] = useState("");
  const [statusPopOver, setStatusPopOver] = useState("warning");
  const [idGratuidade, setIdGratuidade] = useState(0);
  const [errosList, setErrosList] = useState([]);
  const [temGratuidade, setTemGratuidade] = useState(false);
  const [dataCadastroUser, setDataCadastroUser] = useState("");
  const [viewElements, setViewElements] = useState(false);
  const [usuariosPesquisa, setUsuariosPesquisa] = useState([]);
  const [dataUserTicket, setDataUserTicket] = useState([]);
  const [valorPrimeiraVia, setValorPrimeiraVia] = useState("");
  const [pedidoPrimeiraVia, setPedidoPrimeiraVia] = useState(false);
  const [valorSegundaVia, setValorSegundaVia] = useState("");

  // ----------------   data form
  const [cdCliente, setCdCliente] = useState(0);

  const [dataValidade, setDataValidade] = useState(new Date());
  const [dataConcessao, setDataConcessao] = useState("");
  const [dataFimConcessao, setDataFimConcessao] = useState("");
  const [nomeCompleto, setNomeCompleto] = useState("");
  const [nomeMae, setNomeMae] = useState("");
  const [nomeSocial, setNomeSocial] = useState("");
  const [msgAlert, setMsgAlert] = useState("");
  const [email, setEmail] = useState("");
  const [sexo, setSexo] = useState("M");
  const [cpfSearch, setCpfSearch] = useState("");
  const [celular, setCelular] = useState("");
  const [image, setImage] = useState("");
  const [logradouro, setLogradouro] = useState("");
  const [cep, setCep] = useState("");
  const [numero, setNumero] = useState("");
  const [pontoReferencia, setPontoReferencia] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidade, setCidade] = useState("");
  const [estado, setEstado] = useState("");
  const [checkForm, setCheckForm] = useState(false);
  const [isOpenErro, setIsOpenErro] = useState(false);
  const [laudoStatus, setLaudoStatus] = useState(false);
  const [laudoRegra, setLaudoRegra] = useState(false);
  const [idLaudo, setIdLaudo] = useState(0);
  const [alterarBiometria, setAlterarBiometria] = useState(false);
  const [alterarBiometriaFacial, setAlterarBiometriaFacial] = useState(false);

  const recoverLoggedUser: any[] = [JSON.parse(localStorage.getItem("user"))];

  const [matricula, setMatricula] = useState("");
  const [isOpenAlerta, setIsOpenAlerta] = useState(false);
  const [numeroCns, setNumeroCns] = useState("");

  // ----------------   data media
  const [docsObrigatoriosList, setDocsObrigatoriosList] = useState([]);
  const [files, setFiles] = useState([]);
  const [filesReceived, setFilesReceived] = useState([]);
  const [typeNow, setTypeNow] = useState(0);
  const [dataAtual, setDataAtual] = useState(new Date());
  const [addMonth, setAddMonth] = useState(0);
  const [qtdUsoDiario, setQtdUsoDiario] = useState("");
  const [usoIlimitado, setUsoIlimitado] = useState(false);
  const [existePedido, setExistePedido] = useState(false);
  const [tipoPedidoCartao, setTipoPedidoCartao] = useState("");
  const [pedidoSegundaVia, setPedidoSegundaVia] = useState(false);

  const [qtdUsoSemanal, setQtdUsoSemanal] = useState("");
  const [valorTratamento, setValorTratamento] = useState("");
  const [duracaoTratamento, setDuracaoTratamento] = useState("1");
  const [valorFrequenciaTratamento, setValorFrequenciaTratamento] =
    useState("");
  const [duracaoFrequenciaTratamento, setDuracaoFrequenciaTratamento] =
    useState("2");
  const [qtdUsoMensal, setQtdUsoMensal] = useState("");
  const [horaInicio, setHoraInicio] = useState("");
  const [horaFim, setHoraFim] = useState("");
  const [acompanhante, setAcompanhante] = useState(false);
  const [biometria, setBiometria] = useState(false);
  const [tipoErroPedido, setTipoErroPedido] = useState("");
  const [seg, setSeg] = useState(false);
  const [ter, setTer] = useState(false);
  const [qua, setQua] = useState(false);
  const [qui, setQui] = useState(false);
  const [sex, setSex] = useState(false);
  const [sab, setSab] = useState(false);
  const [dom, setDom] = useState(false);
  const [dataRec, setDataRec] = useState("");
  const [nomeUsuario, setNomeUsuario] = useState("");
  const [continuarChamado, setContinuarChamado] = useState(false);
  const [viewElementBusca, setViewElementBusca] = useState(false);
  const [loginNovo, setLoginNovo] = useState(false);
  const [continuarChamadoDisabled, setContinuarChamadoDisabled] =
    useState(false);
  const [novoChamado, setNovoChamado] = useState(false);
  const [solicitarPedido, setSolicitarPedido] = useState(false);
  const [protocoloId, setProtocoloId] = useState(0);
  // ----------------   data validations
  const [historicoStatus, setHistoricoStatus] = useState([]);
  const [statusAtual, setStatusAtual] = useState(0);
  const [limite, setLimite] = useState(0);
  const [statusSalvarLaudo, setStatusSalvarLaudo] = useState(false);
  const [obsRestricao, setObsRestricao] = useState("");
  const [obsLaudo, setObsLaudo] = useState("");

  //--------------ZENDESK------------------------

  const [loadingEncaminhar, setLoadingEncaminhar] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modalNovoChamado, setModalNovoChamado] = useState(false);
  const [botaoConfirmar, setBotaoConfirmar] = useState(false);
  const [valueRadio, setValueRadio] = useState("");
  const [protocolo, setProtocolo] = useState([]);
  const [idTipoEndereco, setIdTipoEndereco] = useState("");
  const [uf, setUF] = useState("");
  const [ticketGerado, setTicketGerado] = useState("");
  const [nrSeqEndereco, setNrSeqEndereco] = useState(0);
  const [observacaoChamado, setObservacaoChamado] = useState("");
  const [dataUser, setDataUser] = useState([]);
  const [dataUser2, setDataUser2] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [cids, setCids] = useState([]);
  const [solicitarCartao, setSolicitarCartao] = useState(false);
  const [handleFotoAlterada2, setHandleFotoAlterada2] = useState(false);
  const [handleFotoAlterada, setHandleFotoAlterada] = useState("");
  const [cepUserNovo, setCepUserNovo] = useState("");
  const [existeLaudo, setExisteLaudo] = useState("");
  const [laudo, setLaudo] = useState<Laudo | null>(null);
  const [clienteProtocolo, setClienteProtocolo] = useState("");
  const [unidadesAtendimento, setUnidadesAtendimento] = useState([]);
  const [unidadesTratamento, setUnidadesTratamento] = useState([]);
  const [ePcd, setEpcd] = useState(false);
  const [codigoUnidadesAtendimento, setCodigoUnidadesAtendimento] =
    useState("");
  const [operadora, setOperadora] = useState([]);
  const [idOperadora, setIdOperadora] = useState<number | null>(null); //tirar depois o dois quando tiver usuario com idOperadora

  const [codigoUnidadesTratamento, setCodigoUnidadesTratamento] = useState("");
  const [listaCids, setListaCids] = useState([]);
  const [codigoCid, setCodigoCid] = useState([]);
  const [stateAlterarBiometria, setStateAlterarBiometria] = useState(false);
  const [loadingCep, setLoadingCep] = useState(false);
  const perfisPermitidosBiometria = [
    "ADMINISTRADOR",
    "ATENDENTE_LOJA",
    "SUPERVISOR_LOJA",
    "ATENDIMENTO_GRATUIDADE_CONCESSAO",
  ];
  const perfisPermitidosLaudo = ["MEDICO_PCD", "ADMINISTRADOR"];
  const perfisPermitidosCartao = [
    "ADMINISTRADOR",
    "SUPERVISOR_LOJA",
    "ATENDENTE_LOJA",
    "ATENDIMENTO_GRATUIDADE_CONCESSAO",
  ];

  const [deficienciaSelect, setDeficienciaSelect] = useState([]);
  let dadosUsuario: any[];
  const deficiencia = [
    { value: 1, label: "Física" },
    { value: 2, label: "Auditiva" },
    { value: 3, label: "Visual" },
    { value: 4, label: "Intelectual" },
    { value: 5, label: "Mental (psicossocial)" },
    { value: 7, label: "TEA - Transtorno de Espectro Autista" },
  ];
  const handleLogout = () => {
    logout();
    push("/auth/sign-in");
  };
  const handleChangeSelectDeficiencia = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedOptions = Array.from(
      event.target.selectedOptions,
      (option) => option.value
    );
    setDeficienciaSelect(selectedOptions);
  };

  // Defina os estilos
  const styles = StyleSheet.create({
    page: {
      flexDirection: "row",
      backgroundColor: "#E4E4E4",
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1,
    },
  });

  interface PerfisUsuario {
    perfis: string[];
  }

  const usuarios: PerfisUsuario[] = [
    {
      perfis: recoverLoggedUser[0]?.perfis,
    },
  ];

  const perfisDesejados = [
    "ADMINISTRADOR",
    "SUPERVISOR_PCD",
    "SUPERVISOR_SENIOR",
    "SUPERVISOR_LOJA",
    "ATENDENTE_LOJA",
    "CADASTRO_PCD",
    "MEDICO_PCD",
  ];

  interface Cid {
    codigoCid: string;
    descricao: string;
    biometriaFacial: boolean;
  }

  interface Laudo {
    cdCliente: number;
    cids: Cid[];
    dataFimValidade: string;
    dataInclusao: string;
    deficienciaPermanente: boolean;
    desativarBiometriaFacial: boolean;
    id: number;
    idTipoFrequenciaTratamento: number;
    idTipoTempoTratamento: number;
    loginAtendente: string;
    necessitaAcompanhante: boolean;
    qtFrequenciaTratamento: number;
    qtTempoTratamento: number;
    txObservacao: string;
  }

  const algumUsuarioCompativel = usuarios.some((usuario) => {
    return usuario.perfis.some((perfil) =>
      perfisPermitidosBiometria.includes(perfil)
    );
  });

  const algumUsuarioCompativelLaudo = usuarios.some((usuario) => {
    return usuario.perfis.some((perfil) =>
      perfisPermitidosLaudo.includes(perfil)
    );
  });

  const perfisDesejadosDataNascimento = ["ADMINISTRADOR", "SUPERVISOR_LOJA"];
  const algumUsuarioCompativelCartao = usuarios.some((usuario) => {
    return usuario.perfis.some((perfil) =>
      perfisPermitidosCartao.includes(perfil)
    );
  });

  //--------------ZENDESK------------------------^^
  const handleCepNovoUser = (cep: any) => {
    setCepUserNovo(cep);
  };

  function fetchDataUnidades() {
    var dataUaps = listarUnidadesUap();
    dataUaps
      .then((resolvedDataUap: any) => {
        let valE = resolvedDataUap.map(
          (v: { codigoUap: any; descricao: any }) => {
            return {
              value: v.codigoUap,
              label: v.descricao,
              colorScheme: "red",
            };
          }
        );
        localStorage.setItem("unidades", JSON.stringify(resolvedDataUap));
        setUnidades(valE);
        // Use valCids aqui dentro ou passe adiante para onde precisar ser utilizado
      })
      .catch((error: any) => {
        // Trate qualquer erro que possa ocorrer durante a resolução da Promise
        showPopOver(
          "error",
          "Ops...",
          "Erro ao buscar Unidades de atenção primária, contate o administrador!"
        );
      });
  }

  const buscaDadosPedidoCartao = (id: any) => {
    if (id) {
      buscarHistoricoPedidoCartao(id, "3").then(function (result: any) {
        if (result !== 400 || result !== 500) {
          if (result?.temPedidoCartaoPrimeiraVia === true) {
            setPedidoPrimeiraVia(true);
            setExistePedido(true);
          } else {
            setPedidoPrimeiraVia(false);
          }

          if (result?.temPedidoCartaoSegundaVia === true) {
            setPedidoSegundaVia(true);
            setExistePedido(true);
          } else {
            setPedidoPrimeiraVia(false);
          }

          if (
            result?.tipoPedido === "1 VIA SOLICITADA" ||
            result?.tipoPedido === "2 VIA SOLICITADA"
          ) {
            setExistePedido(true);
          } else if (result?.tipoPedido === "PODE SOLICITAR PRIMEIRA_VIA") {
            setExistePedido(false);
          } else if (result?.tipoPedido === "PODE SOLICITAR SEGUNDA_VIA") {
            setExistePedido(false);
            setTipoPedidoCartao(result?.tipoPedido);
          } else if (result.tipoPedido === "EXISTE") {
            setExistePedido(true);
          }
        }
      });
    }
  };

  async function fetchDataCids() {
    try {
      resolvedDataCids = await listarCids();

      if (Array.isArray(resolvedDataCids)) {
        const valCids = resolvedDataCids.map(
          (v: { codigoCid: any; descricao: any }) => ({
            value: v.codigoCid,
            label: v.codigoCid + " - " + v.descricao,
            colorScheme: "red",
          })
        );
        localStorage.setItem("cids", JSON.stringify(resolvedDataCids));
        setCids(valCids);
        // Use valCids aqui dentro ou passe adiante para onde precisar ser utilizado
      } else {
        // Trate o caso em que listarCids() não retorna um array
        showPopOver(
          "error",
          "Ops...",
          "Erro ao buscar CIDs, contate o administrador!"
        );
      }
    } catch (error) {
      // Trate qualquer erro que possa ocorrer durante a resolução da Promise
      showPopOver(
        "error",
        "Ops...",
        "Erro ao buscar CIDs, contate o administrador!"
      );
    }
  }

  const changeAcompanhante = (e: any) => {
    if (e === true) {
      showPopOver(
        "warning",
        "Acompanhante...",
        "Beneficiário: " + nomeCompleto + " com direito a acompanhante."
      );
    }
  };

  useEffect(() => {
    if (biometria === true) {
      setAlterarBiometria(true);
      showPopOver(
        "warning",
        "Biometria...",
        "Beneficiário: " + nomeCompleto + " com biometria desativada."
      );
    }
    if (stateAlterarBiometria === true) {
      setAlterarBiometriaFacial(true);
    } else {
      setAlterarBiometriaFacial(false);
    }
  }, [biometria, stateAlterarBiometria]);

  useEffect(() => {
    setUnidadesAtendimento([]);
    if (unidades && unidades.length > 0) {
      const selectedUnidade1 = unidades.find(
        (unidade) =>
          unidade.value == String(codigoUnidadesAtendimento).replace(/\s/g, "")
      );
      const selectedUnidade2 = unidades.find(
        (unidade) =>
          unidade.value == String(codigoUnidadesTratamento).replace(/\s/g, "")
      );
      setUnidadesAtendimento(selectedUnidade1);
      setUnidadesTratamento(selectedUnidade2);
    }
    if (IsEmpty(dataUser)) {
      setDataUser(dataUser2);
    }
  }, [
    dataUser,
    codigoUnidadesAtendimento,
    codigoUnidadesTratamento,
    unidadesAtendimento,
    unidadesTratamento,
    unidades,
    dataUser2,
  ]);

  const handleStatusLaudo = async () => {
    if (
      !IsEmpty(dataUser) &&
      typeof dataUser === "object" &&
      "codigo" in dataUser &&
      ePcd === true
    ) {
      setIsLoading(true);
      if (idLaudo === 0)
        await buscarLaudo(dataUser.codigo).then(function (result) {
          if (
            result &&
            result.id !== " Laudo não encontrado!" &&
            result !== 404 &&
            result !== 500 &&
            result !== 400 // Correção: Adicionando operador lógico aqui
          ) {
            if (result?.deficienciaPermanente === false) {
              if (result?.necessitaAcompanhante === true) {
                setLimite(result?.qtFrequenciaTratamento * 2);
              } else {
                setLimite(result?.qtFrequenciaTratamento);
              }
              setIdLaudo(result?.id);
              setValorTratamento(result?.qtTempoTratamento || "");

              setDataConcessao(result?.dataInclusao);
              setDataFimConcessao(result?.dataFimValidade || "");

              setValorFrequenciaTratamento(
                result?.qtFrequenciaTratamento || ""
              );
              setUsoIlimitado(result?.deficienciaPermanente);

              setValue(result?.deficienciaPermanente ? "2" : "1");
              setDuracaoFrequenciaTratamento(
                result?.idTipoFrequenciaTratamento || "1"
              );
              setDuracaoTratamento(result?.idTipoTempoTratamento || "1");
              setIsLoading(false);
            }
          }
        });
    }
  };

  useEffect(() => {
    if (localStorage.getItem("unidades") === null) {
      fetchDataUnidades();
    } else {
      const unidadesStorage: any[] = JSON.parse(
        localStorage.getItem("unidades") || "[]"
      );
      let valE = unidadesStorage.map(
        (v: { codigoUap: any; descricao: any }) => {
          return {
            value: v.codigoUap,
            label: v.descricao,
            colorScheme: "red",
          };
        }
      );
      setUnidades(valE);
    }
    if (localStorage.getItem("cids") === null) {
      fetchDataCids();
    } else {
      const cidsStorage: any[] = JSON.parse(
        localStorage.getItem("cids") || "[]"
      );
      const valCids = cidsStorage.map(
        (v: { codigoCid: any; descricao: any }) => ({
          value: v.codigoCid,
          label: v.codigoCid + " - " + v.descricao,
          colorScheme: "red",
        })
      );
      setCids(valCids);
    }
  }, []);

  const handleChangeUnidades1 = (event: any) => {
    setUnidadesAtendimento(event);
    setCodigoUnidadesAtendimento(event[0]?.value || event?.value);
  };

  const handleChangeUnidades2 = (event: any) => {
    setUnidadesTratamento(event);
    setCodigoUnidadesTratamento(event[0]?.value || event?.value);
  };
  const handleChangeCids = (event: MultiValue<CidsOption>) => {
    if (event && event.length > 0) {
      const selectedValues = event.map((option) => option.value);
      setCodigoCid(selectedValues);
    } else {
      setCodigoCid([]); // Se nenhum valor estiver selecionado, defina o array como vazio
    }
    setListaCids(Array.from(event));
  };

  async function handleChangeCidsUsuario(event: any) {
    resolvedDataCids = await listarCids();
    const acc: any = [];
    const valCids = resolvedDataCids
      .map((v: any) => {
        event.map((option: any) => {
          if (v.codigoCid === option.codigoCid.replace(/\s/g, "")) {
            acc.push({
              value: v.codigoCid,
              label: v.codigoCid + " - " + v.descricao,
              colorScheme: "red",
            });
          }
        });
      })
      .filter((item: any) => item !== null);
    setListaCids(acc || []);
  }

  let dataLogin;

  interface AtendimentosOption extends OptionBase {
    label: string;
    value: string;
    colorScheme: string;
  }

  interface CidsOption extends OptionBase {
    label: string;
    value: string;
    colorScheme: string;
  }

  const onChangeModalDataClose = () => {
    if (document.getElementById("fotoElementoUsuario"))
      document.getElementById("fotoElementoUsuario").style.display = "block";
    if (document.getElementById("fotoElementoUsuario2"))
      document.getElementById("fotoElementoUsuario2").style.display = "block";
    setModalData(!modalData);
  };

  const onChangeModalConfirmacaoAlteracaoLaudoFechar = () => {
    if (document.getElementById("fotoElementoUsuario"))
      document.getElementById("fotoElementoUsuario").style.display = "block";
    if (document.getElementById("fotoElementoUsuario2"))
      document.getElementById("fotoElementoUsuario2").style.display = "block";
    setIsOpen3(false);
  };

  const onChangeModalConfirmacaoAlteracaoLaudoAbrir = () => {
    setLoading(false);
    if (validateFormLaudo()) {
      if (document.getElementById("fotoElementoUsuario"))
        document.getElementById("fotoElementoUsuario").style.display = "hidden";
      if (document.getElementById("fotoElementoUsuario2"))
        document.getElementById("fotoElementoUsuario2").style.display =
          "hidden";

      setIsOpen3(true);
    }
  };

  const handleFocusChange = async (cepChange: any) => {
    setLoadingCep(true);
    const { estado, cidade, bairro, logradouro } = await buscaCep(cepChange);
    setLoadingCep(false);

    if (!cepChange.includes(".")) {
      setUF(estado);
      setBairro(bairro);
      setCidade(cidade);
      setEstado(estado);
      setLogradouro(logradouro);
      setIdTipoEndereco("2");
      setUF(estado);
    } else {
      setCep(cepChange);
      setUF("");
      setBairro("");
      setCidade("");
      setEstado("");
      setLogradouro("");
    }
  };

  const handleFoto = (foto: any) => {
    if (foto !== "") {
      setImage(foto.replace("data:image/jpeg;base64,", ""));
    }
  };

  const temStatusGratuidade = (codigo: any) => {
    consultarGratuidadePcd(codigo).then(function (result) {
      setLoading(true);
      if (!IsEmpty(result)) {
        const result2 = [result];
        const resultado = result2.filter((gratuidade: any) => {
          return gratuidade.statusGratuidade.descricao === "Aprovado";
        });

        if (resultado.length > 0) {
          setIdGratuidade(resultado[0]?.id);
          setHistoricoStatus(resultado[0]?.historicoStatusGratuidadeList);
          setTemGratuidade(true);
          setLoading(false);
          if (
            resultado[0]?.statusGratuidade.id === 1 ||
            resultado[0]?.statusGratuidade.id == 4
          ) {
            setStatusAtual(1);
          } else {
            setStatusAtual(resultado[0]?.statusGratuidade.id);
          }

          // preenche OBS restricao
          let obsRestricao = resultado[0]?.historicoStatusGratuidadeList.filter(
            (item: any) => item.descricao !== ""
          );
          setObsRestricao(obsRestricao[0]?.descricao);
        } else {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    });
  };

  const confirmarAtendimento = async (row: any) => {
    setDataUser([]);
    setUnidadesAtendimento(null);
    setLoginNovo(false);
    setBotaoConfirmar(true);
    setNovoChamado(true);
    setContinuarChamadoDisabled(true);
    if (!IsEmpty(row)) {
      temStatusGratuidade(row.codigo);
      const gratuidadePCD = await consultaDadosMedicosPCD(row.codigo);
      if (gratuidadePCD?.cdCliente) {
        setNumeroCns(gratuidadePCD?.numeroCns);
        setUnidadesAtendimento(gratuidadePCD?.codigoUap.replace(/\s/g, ""));
        setEpcd(true);
        setCodigoUnidadesAtendimento(
          gratuidadePCD?.codigoUap.replace(/\s/g, "")
        );
      }

      if (row?.tipoDocumento.codigo === 6) {
        setNumeroCns(row.numeroDocumento);
      } else {
        setCpfSearch(maskCpfCnpj(row.numeroDocumento));
      }

      buscaDadosPedidoCartao(row.codigo);
      if (idLaudo === 0)
        await buscarLaudo(row.codigo).then(function (result) {
          if (typeof result === "object" && "id" in result) {
            if (result?.deficienciaPermanente == false) {
              if (result?.necessitaAcompanhante == true) {
                setLimite(result?.qtFrequenciaTratamento * 2);
              } else {
                setLimite(result?.qtFrequenciaTratamento);
              }
            }
            if (result?.codigoUapTratamento) {
              setCodigoUnidadesTratamento(
                result?.codigoUapTratamento.replace(/\s/g, "")
              );
            } else {
              setCodigoUnidadesTratamento(
                gratuidadePCD?.codigoUap.replace(/\s/g, "")
              );
            }
            setStatusAtual(1);
            setCheckForm(true);
            setLaudoStatus(true);
            setDeficienciaSelect(result?.idTipoDoenca);
            temStatusGratuidade(row.codigo);
            setIdLaudo(result?.id);
            setCheckForm(true);
            setBiometria(result?.desativarBiometriaFacial);
            //if (result?.cids) handleChangeCidsUsuario(result?.cids);
            setAcompanhante(result?.necessitaAcompanhante);
            setValorTratamento(result?.qtTempoTratamento || "");

            setDataConcessao(result?.dataInclusao || "");
            setDataFimConcessao(result?.dataFimValidade || "");
            setObsLaudo(result?.txObservacao || "");
            setValorFrequenciaTratamento(result?.qtFrequenciaTratamento || "");
            setUsoIlimitado(result?.deficienciaPermanente);
            setValue(result?.deficienciaPermanente ? "2" : "1");
            setDuracaoFrequenciaTratamento(
              result?.idTipoFrequenciaTratamento || "1"
            );
            setDuracaoTratamento(result?.idTipoTempoTratamento || "1");
          } else {
            setLaudoStatus(false);
          }
        });
    }

    if (!IsEmpty(row)) {
      setViewElementBusca(true);
      setLoginNovo(false);
      setDataUser(row);
      setLoading(false);
      setViewElements(true);
      onOpen();
      onClose();
      setShowForm(true);
      setValueRadio("");

      setObsLaudo(row.obsLaudo || "");

      //----ZENDESK--------------------
      //setCheckForm(true);
      setDataCadastroUser(row.dataCadastro);
      setCdCliente(row.codigo);
      setNomeMae(row.nomeMae);
      setNomeCompleto(row.nome);
      setNomeSocial(row.nomeSocial);
      setDataRec(
        IsNotEmpty(row.dataNascimento)
          ? maskDataInfo(row.dataNascimento + "T00:00:00")
          : ""
      );
      setEmail(row.email);
      setSexo(row.sexo);
      if (IsNotEmpty(row?.telefone)) {
        setCelular(maskCelular(row?.telefone));
      }
      if (IsNotEmpty(row.enderecos[0]?.cep)) {
        setNrSeqEndereco(row.enderecos[0]?.nrSeqEndereco);
        setCep(maskCep(row.enderecos[0]?.cep));
        setLogradouro(row.enderecos[0]?.logradouro);
        setUF(row.enderecos[0]?.uf);
        setBairro(row.enderecos[0]?.bairro);
        setNumero(row.enderecos[0]?.numero);
        setCidade(row.enderecos[0]?.cidade);
        setEstado(row.enderecos[0]?.uf);
        setPontoReferencia(row.enderecos[0]?.complemento);
      }

      //media

      setImage(
        row.base64Imagem
          ? "data:image/jpeg;base64," + row.base64Imagem.replace('"', "")
          : ""
      );
      // cria a gratuidade ou nao caso ja esteja criado
      // handleGetGratuidade(row.codigo, null, "", "0", "post");
    } else if (IsEmpty(row)) {
      setLoginNovo(true);
      setLoading(false);
      setViewElements(true);
      setViewElementBusca(true);
      onClose();
      setShowForm(true);
    } else {
      handleOpenAlert(true);
      setMsgAlert("Erro no sistema, favor tentar novamente!");
    }
    // if ((novoChamado && !IsEmpty(dataUser)) || !IsEmpty(row)) {
    //   cadastrarProtocolo(row, "Início atendimento gratuidade pcd").then(
    //     function (result) {
    //       // cadastrarProtocoloComentario(result.id, "início Atendimento");
    //       setTicketGerado(result.id);
    //       setProtocolo(result.id);
    //     }
    //   );
    // } else if (continuarChamado) {
    //   setProtocolo(dataUserTicket);
    // }
  };
  useEffect(() => {
    if (acompanhante == true && valorFrequenciaTratamento) {
      setLimite(parseInt(valorFrequenciaTratamento) * 2);
    } else {
      setLimite(parseInt(valorFrequenciaTratamento));
    }
  }, [valorFrequenciaTratamento, acompanhante]);

  useEffect(() => {
    setNomeCompleto(nomeCompleto);
  }, [nomeCompleto]);

  // useEffect(() => {
  //   if (statusAtual === 1) {
  //     setLaudoStatus(true);
  //   }
  // }, [statusAtual]);

  useEffect(() => {
    if (!IsEmpty(dataUser)) {
      dadosUsuario = [dataUser];
      if (existeLaudo !== "") {
        existeLaudoCliente(dadosUsuario[0]?.codigo);
      }
    } else {
      setLaudo(null);
    }
    //setDeficienciaSelect(0);
  }, [dataUser, loading]);

  const finalizarAtendimento = () => {
    showPopOver("success", "Atendimento", "Atendimento encerrado com sucesso!");
    setTimeout(() => {
      window.scrollTo(0, 0);
      window.location.href = "/atendimento#/admin/dashboard";
    }, 2000);
  };
  // ZENDESK ---------------------------------^^

  const showPopOver = (status: string, title: string, subtitle: string) => {
    handleOpenAlert(true);
    setStatusPopOver(status);
    setTitlePopOver(title);
    setSubtitlePopOver(subtitle);
  };

  const preencheDiasSemana = (valor: any) => {
    switch (parseInt(valor)) {
      case 1:
        setDom(true);
        break;
      case 2:
        setSeg(true);
        break;
      case 3:
        setTer(true);
        break;
      case 4:
        setQua(true);
        break;
      case 5:
        setQui(true);
        break;
      case 6:
        setSex(true);
        break;
      case 7:
        setSab(true);
        break;
      default:
        break;
    }
  };

  const handleGetGratuidade = async (
    idCliente: any,
    idStatus: any,
    status: string,
    descricao: string,
    acao: string,
    loginAtendimento: any
  ) => {
    let retornoGratuidade = [];

    if (acao === "put") {
      //aqui
      retornoGratuidade = await editaGratuidade({
        id: idGratuidade,
        descricao: descricao ?? "PCD",
        tipoGratuidade: {
          id: idTipoGratuidade,
          descricao: descricao ?? "PCD",
        },
        statusGratuidade: {
          id: idStatus,
          descricao: status,
        },
        loginAtendente: loginAtendimento,
      });
    }
    setIdGratuidade(retornoGratuidade.entidadeRetorno.id);
    setHistoricoStatus(
      retornoGratuidade.entidadeRetorno.historicoStatusGratuidadeList
    );

    // if (
    //   retornoGratuidade.entidadeRetorno.statusGratuidade.id === 1 ||
    //   retornoGratuidade.entidadeRetorno.statusGratuidade.id == 4
    // ) {
    //   setStatusAtual(1);
    // } else {
    //   setStatusAtual(retornoGratuidade.entidadeRetorno.statusGratuidade.id);
    // }

    // // preenche OBS restricao
    // let obsRestricao =
    //   retornoGratuidade.entidadeRetorno.historicoStatusGratuidadeList.filter(
    //     (item: any) => item.descricao !== ""
    //   );
    // setObsRestricao(obsRestricao[0]?.descricao);
  };

  const cancelarGratuidade = async () => {
    setLoading(true);
    var codigoUsuario: any[] = [dataUser];
    var temgratuidadeCliente: any[] = [
      await consultarGratuidadePcd(codigoUsuario[0]?.codigo),
    ];

    if (typeof temgratuidadeCliente === "object") {
      const objetoMaisRecente = temgratuidadeCliente.reduce(
        (maisRecente: any, item: any) => {
          if (item instanceof Array) {
            item.forEach((subItem) => {
              if (subItem.dataInclusao > maisRecente.dataInclusao) {
                maisRecente = subItem;
              }
            });
          } else {
            if (item.dataInclusao > maisRecente.dataInclusao) {
              maisRecente = item;
            }
          }
          return maisRecente;
        }
      );
      if (objetoMaisRecente?.statusGratuidade?.id === 3) {
        handleGetGratuidade(
          codigoUsuario[0]?.codigo,
          5,
          "Cancelado",
          "Cancelado UI-ATENDIMENTO",
          "put",
          recoverLoggedUser[0]?.login
        );
        showPopOver("success", "Gratuidade", "Cancelado!");
      } else {
        showPopOver("error", "Gratuidade", "Erro ao cancelar!");
      }

      setLoading(false);
    }
  };

  const handleSearch = async () => {
    //----ZENDESK-----
    setBotaoConfirmar(true);
    setValueRadio("");
    //----ZENDESK-----^^
    cleanFields();
    if (IsCPF(cpfSearch)) {
      setLoading(true);
      const dataBusca = await pesquisaCliente({
        numeroDocumento: cpfSearch.replace(/[^\d]+/g, ""),
        tipoBusca: "TODOS",
        tipoPessoa: "F",
      });

      if (IsNotEmpty(dataBusca)) {
        //form
        //setShowForm(true);
        //----ZENDESK--------------------
        setDataUser(dataBusca);
        //----ZENDESK--------------------
        //setCheckForm(true);
        setDataCadastroUser(dataBusca[0].dataCadastro);
        setCdCliente(dataBusca[0].codigo);
        setNomeCompleto(dataBusca[0].nome);
        setNomeSocial(dataBusca[0].nomeSocial);
        setDataRec(
          IsNotEmpty(dataBusca[0].dataNascimento)
            ? maskDataInfo(dataBusca[0].dataNascimento + "T00:00:00")
            : ""
        );
        setEmail(dataBusca[0].email);
        setSexo(dataBusca[0].sexo);
        setCelular(maskCelular(dataBusca[0].telefone));
        if (IsNotEmpty(dataBusca[0].enderecos)) {
          setNrSeqEndereco(dataBusca[0].enderecos[0].nrSeqEndereco);
          setCep(maskCep(dataBusca[0].enderecos[0].cep));
          setLogradouro(dataBusca[0].enderecos[0].logradouro);
          setUF(dataBusca[0].enderecos[0].uf);
          setBairro(dataBusca[0].enderecos[0].bairro);
          setNumero(dataBusca[0].enderecos[0].numero);
          setCidade(dataBusca[0].enderecos[0].cidade);
          setEstado(dataBusca[0].enderecos[0].uf);
          setPontoReferencia(dataBusca[0].enderecos[0].complemento);
        }

        //media
        setImage(
          "data:image/jpeg;base64," + dataBusca[0].base64Imagem.replace('"', "")
        );

        // cria a gratuidade ou nao caso ja esteja criado
        // handleGetGratuidade(dataBusca[0].codigo, null, "", "0", "post");

        onOpen();
      } else if (IsEmpty(dataBusca.status) && IsEmpty(dataBusca)) {
        // USUARIO NOVO setShowForm(true);
        onOpen();
        //popOver
        //showPopOver("success", "Usuário Novo", "Prossiga com o cadastro!");
      } else {
        setShowForm(false);
        //popOver
        showPopOver("error", "Ops...", "Erro de conexão!");
        logout();
        push("/auth/sign-in");
      }

      const docsObrigatoriosRet = await docsObrigatorios(2);
      setDocsObrigatoriosList(
        docsObrigatoriosRet.length > 0 ? docsObrigatoriosRet : []
      );
      await setLoading(false);
    } else {
      //popOver
      showPopOver("error", "Ops...", "Digite um CPF válido!");
    }
  };

  const onClickPesquisar = async () => {
    setLoading(true);
    setUsuariosPesquisa([]);
    setDataUser([]);
    if (cpfSearch && !IsCPF(cpfSearch)) {
      showPopOver("error", "Ops...", "Cpf inválido!");
      setLoading(false);
      return;
    }

    if (
      (nomeUsuario.length > 2 && cpfSearch === "") ||
      (nomeUsuario === "" && cpfSearch.length === 14) ||
      (nomeUsuario.length > 2 && cpfSearch.length === 14) ||
      numeroCns.length > 10
    ) {
      const docsObrigatoriosRet = await docsObrigatorios(2);
      setDocsObrigatoriosList(
        docsObrigatoriosRet.length > 0 ? docsObrigatoriosRet : []
      );

      dataLogin = await pesquisaCliente({
        email: null,
        nome: nomeUsuario,
        numeroDocumento:
          cpfSearch.replace(/[^\d]+/g, "") || numeroCns.replace(/[^\d]+/g, ""),
        tipoBusca: "TODOS",
        tipoPessoa: "F",
        pagina: 1,
        quantidadePorPaginacao: 10,
      });
      if (dataLogin === 403 || dataLogin === 401) {
        logout();
      } else if (dataLogin === 400 || dataLogin === 404 || dataLogin === 500) {
        handleOpenAlert(true);
        setMsgAlert(
          "Erro ao fazer pesquisa! Entre em contato com o administrador do sistema."
        );
        setLoading(false);
      } else {
        if (!IsEmpty(dataLogin)) {
          if (dataLogin.length < 5) {
            setHasMore(false);
          } else {
            setHasMore(true);
            setPagina(2);
          }
          setViewElements(false);
          setUsuariosPesquisa(dataLogin);
          setLoading(false);
        } else {
          setUsuariosPesquisa([]);
          setViewElements(false);
          if (cpfSearch || numeroCns) {
            if (!IsEmpty(cpfSearch) || !IsEmpty(numeroCns)) {
              if (
                usuarios[0]?.perfis.some((perfil: string) =>
                  perfisDesejados.includes(perfil)
                )
              ) {
                onOpen();
              } else {
                showPopOver(
                  "error",
                  "Ops...",
                  "Perfil não autorizado a cadastrar novos usuários!"
                );
              }
            } else {
              showPopOver("error", "Ops...", "Cpf inválido!");
            }
          } else {
            showPopOver("warning", "Ops...", "Usuário não encontrado!");
          }
          setLoading(false);
        }
      }
      setLoading(false);
    } else {
      if (nomeUsuario === "" && cpfSearch === "" && numeroCns === "") {
        showPopOver(
          "warning",
          "Ops...",
          "Preencha ao menos um campo para pesquisa!"
        );
      } else if (cpfSearch !== "" && cpfSearch.length < 14) {
        showPopOver("warning", "Ops...", "Preencha com um cpf válido!");
      } else if (numeroCns !== "" && numeroCns.length < 6) {
        showPopOver("warning", "Ops...", "Preencha um  válido!");
      }

      setLoading(false);
    }
  };

  const handleKeyDown = (e: { key: string }) => {
    if (e.key === "Enter") {
      onClickPesquisar();
    }
  };

  const cleanFields = () => {
    setIsentoBiometria(false);
    setValue("1");
    setUnidadesAtendimento([]);
    setUnidadesAtendimento(null);
    setListaCids([]);
    setEpcd(false);
    setStatusAtual(0);
    setDataConcessao("");
    setDataFimConcessao("");
    setValorTratamento("");
    setValorFrequenciaTratamento("");
    setUsoIlimitado(false);
    setDuracaoFrequenciaTratamento("2");
    setLimite(0);
    setExistePedido(false);
    setDeficienciaSelect([]);
    setStatusSalvarLaudo(false);
    setNomeMae("");
    setObsLaudo("");
    setAlterarBiometria(false);
    setBiometria(false);
    setCheckForm(false);
    setIdLaudo(0);
    setShowForm(false);
    setNomeUsuario("");
    setViewElementBusca(false);
    setUsuariosPesquisa([]);
    setTemGratuidade(false);
    setLaudoStatus(false);
    setLoading(false);
    setCheckForm(false);
    setIdGratuidade(0);
    setDataCadastroUser("");
    setDataUser([]);
    setValorTratamento("");
    setValorFrequenciaTratamento("");

    //
    setCpfSearch("");
    setNumeroCns("");
    setCdCliente(0);
    setNomeCompleto("");
    setNomeSocial("");
    setDataRec("");
    setEmail("");
    setSexo("M");
    setCelular("");
    setCep("");
    setUF("");
    setLogradouro("");
    setBairro("");
    setNumero("");
    setCidade("");
    setEstado("");
    setPontoReferencia("");
    setImage("");

    // UPLOADS FILES
    setFiles([]);
    setFilesReceived([]);

    setAcompanhante(false);
    setBiometria(false);
    setDataValidade(new Date());
    setAddMonth(0);
    setQtdUsoDiario("");
    setQtdUsoMensal("");
    setQtdUsoSemanal("");
    setHoraInicio("");
    setHoraFim("");
    setSeg(false);
    setTer(false);
    setQua(false);
    setQui(false);
    setSex(false);
    setSab(false);
    setDom(false);

    setHistoricoStatus([]);
    setObsRestricao("");

    setActiveBullets({
      form: true,
      rules: false,
      regras: false,
      media: false,
      cartao: false,
      validation: false,
    });
  };
  const handleSelect = (ranges: any) => {
    setSelectedDateRange(ranges.selection);
  };
  const handleOpenAlert = (
    status: boolean | ((prevState: boolean) => boolean)
  ) => {
    setIsOpen2(status);
  };
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const validaUnidadeAtendimento = async () => {
    if (dataUser && "codigo" in dataUser) {
      const gratuidadePCD = await consultaDadosMedicosPCD(dataUser?.codigo);
      // Verifica se gratuidadePCD é uma string
      if (typeof gratuidadePCD === "string") {
        setEpcd(true);
      } else {
        // Verifica se o atributo 'cdCliente' NÃO existe no objeto gratuidadePCD
        if (!("cdCliente" in gratuidadePCD)) {
          formTab.current.click();
          setActiveBullets({
            form: true,
            rules: false,
            regras: false,
            media: false,
            cartao: false,
            validation: false,
          });

          showPopOver(
            "error",
            "Ops...",
            "Preencha a UAP e(ou) salve o cadastro!"
          );
        }
      }
    }
  };

  const handleChangeMask = (event: { target: { value: any } }) => {
    const { value } = event.target;
    if (value.length < 15) {
      const valueRet = maskCpfCnpj(value);
      setCpfSearch(valueRet);
    }
  };

  const handleValorCadSus = (event: { target: { value: any } }) => {
    const { value } = event.target;
    setNumeroCns(value);
  };

  const validateFormLaudo = () => {
    let erros = [];
    if (IsEmpty(listaCids)) erros.push("O campo de Cid deve ser preenchido!");
    if (!valorTratamento && usoIlimitado === false)
      erros.push("O tempo de tratamento deve ser preenchido!");
    if (!valorFrequenciaTratamento && usoIlimitado === false)
      erros.push("A frequência de tratamento deve ser preenchida!");
    if (isEmpty(unidadesTratamento) || unidadesTratamento === undefined) {
      erros.push("A unidade de tratamento deve ser preenchida!");
    }

    if (IsEmpty(erros)) {
      return true;
    } else {
      setErrosList(erros);
      erros.map((e) => {
        showPopOver("error", "Ops...", e);
        return false;
      });
    }
  };

  const validateForm = () => {
    let erros = [];

    if (IsEmpty(nomeCompleto)) {
      erros.push("Nome completo deve ser preenchido!");
    }
    if (["Partiu"].some((env) => window.config.tenant.includes(env))) {
      if (idOperadora === null) {
        erros.push("Escolha a operadora!");
      }
    }
    if (IsEmpty(nomeCompleto)) {
      erros.push("Nome completo deve ser preenchido!");
    }
    if (IsEmpty(cpfSearch)) {
      erros.push("CPF deve ser preenchido!");
    }
    if (IsEmpty(nomeMae)) {
      erros.push("Nome da mãe deve ser preenchido!");
    }
    if (IsEmpty(unidadesAtendimento)) {
      erros.push("A unidade de atendimento deve ser preenchida!");
    }

    if (IsNotEmpty(cep)) {
      if (IsEmpty(logradouro)) {
        erros.push("Logradouro deve ser preenchido!");
      }
      if (IsEmpty(numero)) {
        erros.push("Número do endereço deve ser preenchido!");
      }
      if (IsEmpty(bairro)) {
        erros.push("Bairro deve ser preenchido!");
      }
      if (IsEmpty(cidade)) {
        erros.push("Cidade deve ser preenchido!");
      }
      if (IsEmpty(estado)) {
        erros.push("Estado deve ser preenchido!");
      }
    } else {
      erros.push("Cep deve ser preenchido!");
    }

    if (!IsEmpty(email)) {
      if (!isEmail(email)) {
        erros.push("Preencha com um email válido!");
      }
    }

    if (IsEmpty(dataRec)) {
      erros.push("Data de nascimento deve ser válida!");
    }

    if (numeroCns) {
      if (numeroCns.length === 15) {
        if (!validaCnsProv(numeroCns)) {
          erros.push("CNS deve ser válido!");
        }
      }
    }

    if (IsEmpty(erros)) {
      return true;
    } else {
      setErrosList(erros);
      erros.map((e) => {
        showPopOver("error", "Ops...", e);
        return false;
      });
    }
    setLoading(false);
  };

  // useEffect(() => {
  //   setUsoIlimitado(false);
  //   setDuracaoTratamento("");
  //   setValorTratamento("");
  //   setDuracaoFrequenciaTratamento("");
  //   setValorFrequenciaTratamento("");
  //   setAcompanhante(false);
  // }, []);

  const onClickLimparFiltros = async () => { };

  const progressGratuidade = () => {
    let ok = 0;
    if (checkForm) ok++;
    if (IsNotEmpty(image)) ok++;
    if (
      files.length === docsObrigatoriosList.length ||
      filesReceived.length >= docsObrigatoriosList.length
    )
      ok++;

    return ok;
  };
  type Endereco = {
    nrSeqEndereco: number;
    logradouro: string;
    complemento: string;
    bairro: string;
    cidade: string;
    uf: string;
    cep: string;
    numero: string;
    dataInativacao: string | null;
  };

  function obterEnderecoMaisRecente(enderecos: Endereco[]): Endereco {
    if (enderecos?.length === 0) return;
    return enderecos?.reduce((prev, curr) =>
      prev?.nrSeqEndereco > curr?.nrSeqEndereco ? prev : curr
    );
  }

  function obterEnderecosMaisRecentes(lojas: any) {
    if (lojas.length === 0) return;
    return lojas.map((loja: any) => {
      const enderecoMaisRecente = obterEnderecoMaisRecente(loja.enderecos);
      return {
        ...loja,
        enderecos: [enderecoMaisRecente],
      };
    });
  }
  useEffect(() => {
    if (localStorage.getItem("lojas")) {
      setListaDeLojas(
        obterEnderecosMaisRecentes(JSON.parse(localStorage.getItem("lojas")))
      );
    } else {
      const fetchLojas = async () => {
        const res = await buscarLojasNaAPI();
        if (typeof res !== "undefined" && Array.isArray(res)) {
          localStorage.setItem("lojas", JSON.stringify(res));
          setListaDeLojas(obterEnderecosMaisRecentes(res));
          setLojaSelecionada(res[0].codigo);
        } else if (res === 403) {
          setTimeout(() => {
            showPopOver("error", "Ops..", "Sessão expirada, logue novamente!");
          }, 3000);
          handleLogout();
        } else {
          showPopOver(
            "error",
            "Lojas",
            "Erro ao buscar lojas, contate o administrador!"
          );
        }
      };
      if (localStorage.getItem("lojas") === null) {
        fetchLojas();
      } else {
        setListaDeLojas(
          obterEnderecosMaisRecentes(
            localStorage.getItem("lojas")
              ? JSON.parse(localStorage.getItem("lojas") || "")
              : []
          )
        );
        setLojaSelecionada(
          localStorage.getItem("lojas")
            ? JSON.parse(localStorage.getItem("lojas") || "")[0].codigo
            : null
        );
      }
    }
  }, []);

  useEffect(() => {
    if (biometria === true || menor12Anos(dataRec)) {
      setIsentoBiometria(true);
      //showPopOver("warning", "Biometria", "A biometria será desativada!");
    }
  }, [idLaudo]);

  useEffect(() => {
    if (laudoStatus === true) {
      setEpcd(true);
    }
  }, [laudoStatus]);

  const salvarDadosMedicos = async (idCodCliente: number) => {
    if (idCodCliente) {
      const idGratuidadePCD = await consultaDadosMedicosPCD(idCodCliente);
      const bodyDadosMedicos = {
        cdCliente: idCodCliente,
        numeroCns: numeroCns !== "" ? numeroCns : null,
        codigoUap: codigoUnidadesAtendimento,
      };

      if (
        typeof idGratuidadePCD === "object" &&
        "cdCliente" in idGratuidadePCD &&
        ePcd === true
      ) {
        alterarDadosMedicos(bodyDadosMedicos);
        setLaudoStatus(true);
        setLaudoRegra(!laudoRegra);
        setEpcd(true);
      } else {
        cadastrarDadosMedicos(bodyDadosMedicos);
        setEpcd(true);
        setLaudoStatus(true);
        setLaudoRegra(!laudoRegra);
      }
    }
  };
  const nextPageMedia = async () => {
    setLoading(true);
    if (validateForm()) {
      let retornoCliente = [];
      if (cdCliente === 0) {
        // cliente novo
        cliente.base64Imagem = handleFotoAlterada
          ? handleFotoAlterada.replace("data:image/jpeg;base64,", "")
          : image.replace("data:image/jpeg;base64,", "");

        cliente.tipoImagem = "IMAGEM_ROSTO";
        cliente.nome = toCamelCase(nomeCompleto);

        if (cpfSearch === "" && numeroCns !== "") {
          cliente.tipoDocumento = "CNS";
          cliente.numeroDocumento = maskOnlyNumbers(numeroCns);
        } else if (cpfSearch !== "" && numeroCns !== "") {
          cliente.tipoDocumento = "CPF";
          cliente.numeroDocumento = maskOnlyNumbers(cpfSearch);
          cliente.numeroDocumentoAlternativo = numeroCns && null;
        } else {
          cliente.tipoDocumento = "CPF";
          cliente.numeroDocumento = maskOnlyNumbers(cpfSearch);
        }

        cliente.dataNascimento = convertData(dataRec);
        cliente.email = email;
        cliente.celular = maskOnlyNumbers(celular);
        cliente.telefone = maskOnlyNumbers(celular);
        cliente.sexo = "";
        cliente.nomeMae = nomeMae.trim();
        cliente.nomePai = "";
        cliente.nomeSocial = nomeSocial;
        cliente.senha = "";
        cliente.idOperadora = null;
        cliente.confirmacaoSenha = "";
        if (IsNotEmpty(cep)) {
          cliente.cidade = cidade;
          cliente.cep = maskOnlyNumbers(cep);
          cliente.bairro = bairro;
          cliente.logradouro = logradouro;
          cliente.numero = numero;
          cliente.idTipoEndereco = 2;
          cliente.complemento = pontoReferencia;
          cliente.uf = uf;
        } else {
          delete cliente.cidade;
          delete cliente.cep;
          delete cliente.nrSeqEndereco;
          delete cliente.bairro;
          delete cliente.logradouro;
          delete cliente.numero;
          delete cliente.idTipoEndereco;
          delete cliente.complemento;
          delete cliente.uf;
          delete cliente.idTipoLogradouro;
          delete cliente.latitude;
          delete cliente.longitude;
          delete cliente.id;
        }
        cliente.idTiposPerfisCliente = [2];

        await checkUserDoc(
          cliente.numeroDocumento,
          cliente.nome,
          cliente.dataNascimento
        ).then(async function (result) {
          if (result !== 500 && result !== 400 && result !== 404) {
            if (typeof result !== "number" && result.data) {
              var nationalRegistrationStatusApproved =
                result?.data?.nationalRegistrationStatusApproved;
              var nameApproved = result?.data?.nameApproved;
              var birthDateApproved = result?.data?.birthDateApproved;

              if (
                (nationalRegistrationStatusApproved === true &&
                  nameApproved === true &&
                  birthDateApproved === true) ||
                menor18Anos(cliente.dataNascimento) ||
                window.config.tenant === "Dev" ||
                window.config.tenant === "Homolog" ||
                window.config.tenant === "Partiu"
              ) {
                retornoCliente = await cadastraCliente(cliente);
                if (!IsEmpty(retornoCliente)) {
                  setCdCliente(retornoCliente.codigo);
                  setDataUser(retornoCliente);
                  setNomeCompleto(retornoCliente.nome);

                  const bodyDataUserNovo = {
                    numeroDocumento: cpfSearch,
                    nome: retornoCliente.nome,
                    email: email,
                  };
                  // if (!ticketGerado ?? !protocolo) {
                  //   cadastrarProtocolo(
                  //     cliente,
                  //     "Início atendimento gratuidade pcd"
                  //   ).then(function (result) {
                  //     // cadastrarProtocoloComentario(result.id, "início Atendimento");
                  //     setTicketGerado(result.id);
                  //     setProtocolo(result.id);
                  //   });
                  // }
                  salvarDadosMedicos(retornoCliente.codigo);

                  showPopOver("success", "Cadastro", "Salvo com sucesso!");

                  //setCheckForm(true);

                  rulesTab.current.click();
                  setActiveBullets({
                    form: true,
                    rules: true,
                    regras: false,
                    media: false,
                    cartao: false,
                    validation: false,
                  });

                  setLoading(false);
                } else if (
                  retornoCliente === 400 ||
                  retornoCliente === 500 ||
                  retornoCliente === 404
                ) {
                  showPopOver("error", "Cadastro", "Erro ao cadastrar!");
                  setLoading(false);
                }
              } else {
                if (nationalRegistrationStatusApproved == false) {
                  showPopOver("error", "Ops...", "Cpf inválido! Erro Dock!");
                }

                if (nameApproved == false) {
                  showPopOver(
                    "error",
                    "Ops...",
                    "Nome informado não condiz com o nome registrado no documento!"
                  );
                }

                if (birthDateApproved == false) {
                  showPopOver(
                    "error",
                    "Ops...",
                    "Data nascimento informado não condiz com a data registrado no documento!"
                  );
                }
                setLoading(false);
              }
            }
          } else {
            showPopOver("error", "Ops...", "Erro ao validar cadastro na Dock!");

            setLoading(false);
          }
        });
      } else if (cdCliente > 0) {
        // alteração de cliente
        alterarBiometria
          ? (cliente.base64Imagem = image.replace(
            "data:image/jpeg;base64,",
            ""
          ))
          : (cliente.base64Imagem = handleFotoAlterada
            ? handleFotoAlterada.replace("data:image/jpeg;base64,", "")
            : image.replace("data:image/jpeg;base64,", ""));

        cliente.tipoImagem = "IMAGEM_ROSTO";
        cliente.nome = toCamelCase(nomeCompleto);
        cliente.nomeSocial = nomeSocial;
        cliente.dataNascimento = convertData(dataRec);
        cliente.email = email;
        cliente.id = cdCliente;
        cliente.nomeMae = nomeMae.trim();
        cliente.idOperadora = null;
        if (cpfSearch === "" && numeroCns !== "") {
          cliente.tipoDocumento = "CNS";
          cliente.numeroDocumento = numeroCns;
        } else if (cpfSearch !== "" && numeroCns !== "") {
          cliente.tipoDocumento = "CPF";
          cliente.numeroDocumento = maskOnlyNumbers(cpfSearch);
          cliente.numeroDocumentoAlternativo = numeroCns;
        } else {
          cliente.tipoDocumento = "CPF";
          cliente.numeroDocumento = maskOnlyNumbers(cpfSearch);
        }

        cliente.celular = maskSemPontos(celular);
        cliente.telefone = maskSemPontos(celular);
        cliente.sexo = sexo;
        if (IsNotEmpty(cep)) {
          cliente.cidade = cidade;
          cliente.cep = maskOnlyNumbers(cep);
          cliente.nrSeqEndereco = nrSeqEndereco || 0;
          cliente.bairro = bairro;
          cliente.logradouro = logradouro;
          cliente.numero = numero;
          cliente.idTipoEndereco = 2;
          cliente.complemento = pontoReferencia;
          cliente.uf = uf;
        } else {
          delete cliente.cidade;
          delete cliente.cep;
          delete cliente.nrSeqEndereco;
          delete cliente.bairro;
          delete cliente.logradouro;
          delete cliente.numero;
          delete cliente.idTipoEndereco;
          delete cliente.complemento;
          delete cliente.uf;
          delete cliente.idTipoLogradouro;
          delete cliente.latitude;
          delete cliente.longitude;
        }
        if (dataUser) {
          delete cliente.senha;
          delete cliente.confirmacaoSenha;
        }
        cliente.idTiposPerfisCliente = [2];
        delete cliente.nomePai;

        if (menor12Anos(dataRec)) {
          setIsentoBiometria(true);
        } else {
          setIsentoBiometria(false);
        }

        alteraClienteAtendimento2(cliente).then(function (result: any) {
          if (result.status === 200 || result.status < 400) {
            salvarDadosMedicos(cliente.id);
            setAlterarBiometriaFacial(true);
            showPopOver("success", "Cadastro", "Cadastro alterado!");
            setLoading(false);
          } else {
            setCheckForm(false);
            setActiveBullets({
              form: true,
              rules: false,
              regras: false,
              media: false,
              cartao: false,
              validation: false,
            });
            formTab.current.click();
            const data = result?.response?.data;
            const erro =
              data?.errorMessages === undefined || isEmpty(data?.errorMessages)
                ? data
                : data?.errorMessages;

            showPopOver("error", "Ops...", "Erro ao alterar usuário! ");
            setLoading(false);
          }
        });
      }
    } else {
      setAlterarBiometriaFacial(false);
      formTab.current.click();
      setActiveBullets({
        form: true,
        rules: false,
        regras: false,
        media: false,
        cartao: false,
        validation: false,
      });
    }
  };

  const VerificDataLaudoExpirada = (dataFimValidade: any) => {
    const validade = new Date(dataFimValidade);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (validade < today) {
      showPopOver("warning", "Gratuidade", "Benefício expirado!");
    }
  };

  useEffect(() => {
    const carregarLaudo = async () => {
      if (dataUser && "codigo" in dataUser) {
        try {
          const laudo = await buscarLaudo(dataUser.codigo);
          if (laudo?.id) {
            setExisteLaudo(laudo.id);
            setLaudo(laudo);
            VerificDataLaudoExpirada(laudo.dataFimValidade);
            setIdLaudo(laudo.id);
            setDeficienciaSelect([]);

            if (Array.isArray(laudo?.tiposDoencas)) {
              laudo.tiposDoencas.forEach((i: any) => {
                setDeficienciaSelect((prevState: any) => [
                  ...prevState,
                  i.idTipoDoenca,
                ]);
              });
            }

            if (
              laudo.dataInclusao &&
              laudo.idTipoTempoTratamento &&
              laudo.qtTempoTratamento
            ) {
              const dataInicio = new Date(laudo.dataInclusao);
              const dataFim = new Date(dataInicio);

              if (laudo.idTipoTempoTratamento === 1) {
                // 1 = semanas
                dataFim.setDate(
                  dataInicio.getDate() + laudo.qtTempoTratamento * 7
                );
              } else if (laudo.idTipoTempoTratamento === 2) {
                // 2 = meses
                dataFim.setMonth(
                  dataInicio.getMonth() + laudo.qtTempoTratamento
                );
              }
              dataFim.setDate(dataFim.getDate() + 1);
              setLaudo((prev: any) => ({
                ...prev,
                dataFimValidade: dataFim.toISOString(),
              }));

              // 2. E/ou verificar se já expirou:
              const expirado = new Date() > dataFim;
              if (dataFimConcessao === "") {
                setDataFimConcessao(dataFim.toISOString());
              }
            }

            if (Array.isArray(laudo?.cids)) {
              const novaListaCids: CidsOption[] = laudo?.cids
                .map((cid: any) => {
                  const codigoLimpo = String(cid?.codigoCid || "").replace(
                    /\s/g,
                    ""
                  );
                  const descricao = cid?.descricao?.trim() || "";

                  if (!codigoLimpo) return null;

                  return {
                    label: `${codigoLimpo} - ${descricao}`,
                    value: codigoLimpo,
                    colorScheme: "red", // ou o que fizer sentido no seu app
                  };
                })
                .filter(Boolean); // remove nulos
              setListaCids(novaListaCids);
            }
          } else {
            setExisteLaudo("");
            setIdLaudo(0);
            setLaudo(null);
          }
        } catch (error) {
          console.error("Erro ao buscar laudo:", error);
        }
      }
    };
    if (!laudo) carregarLaudo();
  }, [dataUser]);

  const existeLaudoCliente = async (id: any) => {
    if (idLaudo === 0)
      await buscarLaudo(id)
        .then((laudo) => {
          if (laudo?.id) {
            setExisteLaudo(laudo.id);
            setLaudo(laudo);
            VerificDataLaudoExpirada(laudo?.dataFimValidade);
            setIdLaudo(laudo.id);
            setDeficienciaSelect([]);
            laudo?.tiposDoencas &&
              laudo?.tiposDoencas.forEach((i: any) => {
                setDeficienciaSelect((prevState: any) =>
                  Array.isArray(prevState)
                    ? [...prevState, i.idTipoDoenca]
                    : [i.idTipoDoenca]
                );
              });
          } else {
            setExisteLaudo("");
            setIdLaudo(0);
            setLaudo(null);
          }
        })
        .catch((error) => {
          // Trate erros aqui, se necessário
        });
  };

  const salvarLaudoConcederBeneficio = async () => {
    if (validateFormLaudo()) {
      setLoading(true);

      let dadosUsuario: any[] = [dataUser];
      const selectedValues = listaCids.map((option) => option.value);
      //existeLaudoCliente(dadosUsuario[0].codigo);
      const bodyLaudo: {
        id: any | null;
        cdCliente: string;
        cids: string[];
        deficienciaPermanente: boolean;
        necessitaAcompanhante: boolean;
        desativarBiometriaFacial: boolean;
        tiposDoencas?: string[]; // Definindo a propriedade como opcional
        idTipoTempoTratamento: number | null;
        qtTempoTratamento: number | null;
        idTipoFrequenciaTratamento: number | null;
        qtFrequenciaTratamento: number | null;
        loginAtendente: string;
        txObservacao: string;
        codigoUapTratamento: string;
      } = {
        id: idLaudo || null,
        cdCliente: dadosUsuario[0].codigo,
        cids: codigoCid && selectedValues,
        deficienciaPermanente: value === "2" ? true : false,
        necessitaAcompanhante: acompanhante || false,
        desativarBiometriaFacial: biometria || false,
        tiposDoencas: deficienciaSelect,
        idTipoTempoTratamento:
          value === "2" ? null : parseInt(duracaoTratamento || "1"),

        idTipoFrequenciaTratamento:
          value === "2" ? null : parseInt(duracaoFrequenciaTratamento || "2"),
        qtTempoTratamento: value === "2" ? null : parseInt(valorTratamento),
        qtFrequenciaTratamento:
          value === "2" ? null : parseInt(valorFrequenciaTratamento),
        loginAtendente: recoverLoggedUser[0].login,
        txObservacao: obsLaudo,
        codigoUapTratamento:
          codigoUnidadesTratamento || codigoUnidadesAtendimento,
      };

      if (biometria === true) {
        setIsentoBiometria(true);
      } else {
        setIsentoBiometria(false);
      }

      if (value === "1") {
        delete bodyLaudo.tiposDoencas;
      }

      if (idLaudo === 0 || idLaudo === null || idLaudo === undefined) {
        delete bodyLaudo.id;
        const novoBodyLaudo = { ...bodyLaudo };
        if ("id" in novoBodyLaudo) {
          delete novoBodyLaudo.id;
        }
        salvarLaudo(novoBodyLaudo).then(function (result) {
          // @ts-ignore
          if (result === 200 || result < 400) {
            showPopOver("success", "Gratuidade", "Gratuidade concedida!");
            setLimite(0);
            setLaudoStatus(true);
            setLoading(false);
            regrasTab.current.click();
            setActiveBullets({
              form: true,
              rules: true,
              regras: true,
              media: false,
              cartao: false,
              validation: false,
            });
            setCheckForm(true);
            setStatusAtual(1);
            setStatusSalvarLaudo(true);
            onChangeModalConfirmacaoAlteracaoLaudoFechar();
            handleStatusLaudo();
          } else {
            showPopOver("error", "Gratuidade", "Erro ao conceder gratuidade!");
            setLoading(false);
            setStatusAtual(0);
          }
        });
      } else {
        alterarLaudo(bodyLaudo).then(function (result) {
          // @ts-ignore
          if (result === 200 || result < 400) {
            showPopOver(
              "success",
              "Laudo",
              "Laudo salvo / gratuidade concedida!"
            );
            setLimite(0);
            setLaudoStatus(true);
            setLoading(false);
            regrasTab.current.click();
            setActiveBullets({
              form: true,
              rules: true,
              regras: true,
              media: false,
              cartao: false,
              validation: false,
            });
            setStatusAtual(1);
            onChangeModalConfirmacaoAlteracaoLaudoFechar();
            handleStatusLaudo();
          } else {
            showPopOver("error", "Laudo", "Erro ao salvar laudo!");
            onChangeModalConfirmacaoAlteracaoLaudoFechar();
            setLoading(false);
            setStatusAtual(0);
          }
        });
      }
    }
  };

  const toCamelCase = (input: string) => {
    return input.replace(/[-_](.)/g, (_, char: string) => char.toUpperCase());
  };

  const nextFinallyFree = async () => {
    setLoading(true);
    let retornoGratuidade: any[] = [];
    let dadosUsuario: any[] = [dataUser];
    await consultarGratuidadePcd(dadosUsuario[0].codigo).then(async function (
      result
    ) {
      const busca = [result];
      if (!IsEmpty(result) && result !== null) {
        const resultado = busca
          .map((gratuidade: any) => {
            const itemEncontrado = gratuidade.tipoGratuidade;

            return {
              ...gratuidade,
              tipoGratuidade: itemEncontrado ? [itemEncontrado] : [],
            };
          })
          .filter((item: any) => item.tipoGratuidade.length > 0);

        retornoGratuidade = await editaGratuidade({
          id: resultado[0]?.id,
          descricao: obsLaudo ?? "PCD",
          tipoGratuidade: {
            id: 3,
            descricao: "PCD",
          },
          statusGratuidade: {
            id: 3,
            descricao: "Aprovado",
          },
          loginAtendente: recoverLoggedUser[0]?.login,
        });

        //popOver

        setIdGratuidade(resultado[0]?.id);
        setHistoricoStatus(resultado[0]?.historicoStatusGratuidadeList);

        if (
          resultado[0]?.statusGratuidade.id === 1 ||
          resultado[0]?.statusGratuidade.id == 4
        ) {
          setStatusAtual(1);
        } else {
          setStatusAtual(resultado[0]?.statusGratuidade.id);
        }

        // preenche OBS restricao
        let obsRestricao = resultado[0]?.historicoStatusGratuidadeList.filter(
          (item: any) => item.descricao !== ""
        );
        if (!IsEmpty(obsRestricao)) {
          setObsRestricao(obsRestricao[0]?.descricao || "");
        }
        setStatusAtual(3);

        showPopOver("success", "Gratuidade", "Solicitada!");

        setLoading(false);
        mediaTab.current.click();
      } else {
        showPopOver("error", "Gratuidade", "Erro ao aprovar gratuidade!");
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    const fetchOperadoras = async () => {
      const operadorasResponse = await getOperadoras();
      if (
        !isEmpty(operadorasResponse) &&
        operadorasResponse !== 500 &&
        operadorasResponse !== 400 &&
        operadorasResponse !== 404
      ) {
        localStorage.setItem("operadoras", JSON.stringify(operadorasResponse));
        setOperadora(operadorasResponse);
      }
    };
    if (localStorage.getItem("operadoras") === null) {
      fetchOperadoras();
    } else {
      setOperadora(JSON.parse(localStorage.getItem("operadoras")));
    }
  }, []);

  const handlePedido = async () => {
    let usuarioPedido: any[] = [dataUser];
    const bodyPedido: { [key: string]: any } = {
      idCliente: usuarioPedido[0]?.codigo,
      idProduto: 3,
      numeroDocumento: usuarioPedido[0]?.numeroDocumento,
      nrSeqEndereco:
        codigoLojaSelecionada !== 0
          ? codigoLojaSelecionada
          : listaDeLojas[0]?.enderecos[0]?.nrSeqEndereco,
      isAluno: false,
      idTipoMidia: 1,
      //codigoEscola: null
    };

    const pedidoCartao = await finalizarPedidoCartao(bodyPedido);

    if (
      pedidoCartao === 400 ||
      pedidoCartao == 500 ||
      pedidoCartao === 403 ||
      pedidoCartao === 404
    ) {
      showPopOver("error", "Solicitar cartão", "Erro ao solicitar cartão!");
      setLoading(false);
    } else {
      showPopOver("success", "Cartão", "Solicitado!");
      setLoading(false);
    }
    setExistePedido(true);
    setSolicitarPedido(true);
    setStatusAtual(3);
    validationTab.current.click();
  };

  const validateFormData = (valDate: any) => {
    let erros = [];
    if (!isDateStringValid(valDate)) {
      erros.push("Data de Nascimento deve ser válida!");
    }
    if (IsEmpty(erros)) {
      return true;
    } else {
      setErrosList(erros);
      erros.map((e) => {
        showPopOver("error", "Ops..", e);
        return false;
      });
    }
  };
  const fetchMoreData = () => {
    setIsLoading(true);
    if (hasMore) {
      pesquisaCliente({
        email: null,
        nome: nomeUsuario,
        numeroDocumento: cpfSearch
          ? cpfSearch.replace(/[^\d]+/g, "")
          : numeroCns.replace(/[^\d]+/g, ""),
        tipoBusca: "TODOS",
        tipoPessoa: "F",
        pagina: pagina,
        quantidadePorPaginacao: 10,
      }).then(async (resultado) => {
        if (resultado.length > 0) {
          var cont = pagina + 1;
          setPagina(cont);
          setIsLoading(false);
          // setPesquisar(false);
          setUsuariosPesquisa((prevItems) => [...prevItems, ...resultado]);
        } else if (resultado.length < 10) {
          //setPesquisar(false);
          setIsLoading(false);
          setHasMore(false);
        }
      });
    } else {
      setIsLoading(false);
    }
  };
  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    event.preventDefault(); // Impede o evento de colar
    showPopOver("warning", "Ops...", "Não é possível colar no campo!");
  };

  const handlePrint = () => {
    const printWindow = window.open("", "", "width=600,height=600");
    const selectedValues = listaCids.map((option) => option.value);
    let recoverLoggedUser = [JSON.parse(localStorage.getItem("user"))];

    printWindow.document.open();
    printWindow.document.write(`
    <!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Laudo</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      margin: 0;
      padding: 0;
      background-color: #f4f4f4;
    }
    .container {
      max-width: 800px;
      margin: 10px auto;
      padding: 10px;
      background-color: #fff;
    }
    .header {
      text-align: center;
      margin-bottom: 20px;
    }
    .header h1 {
      margin: 0;
      color: #333;
    }
    .content {
      margin-bottom: 20px;
    }
    .content2 {
      margin-bottom: 20px;
      text-align: center;
    font-size: 0.9em;
    }
    
    .content table {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 20px;
    }
    .content table, .content th, .content td {
      border: 1px solid #ddd;
    }
    .content th, .content td {
      padding: 10px;
      text-align: left;
    }
    .content th {
      background-color: #f4f4f4;
    }
    .footer {
      text-align: center;
      font-size: 0.9em;
      color: #777;
    }
  </style>
</head>
<body>

<div class="container">
<img src="${saudePng}" alt="Logo Saúde" style="width:171px; height: 51px;" />
    <div class="header">
      <h1>Laudo Médico</h1>
    </div>
    <div class="footer">
    Benefício de gratuidade concedido para uso em linhas municipais de ônibus, micro-ônibus, BRT e VLT na cidade do Rio de Janeiro, conforme a Lei Municipal nº 3.167/2000 e o Decreto municipal nº 44.728 de 12 de julho de 2018, que deu nova redação ao Decreto 41.575/2016.
    </div>
    <br><br>
    <div class="content">
      <table>
        <tr>
          <th>Beneficiário:</th>
          <td>${nomeUsuario || nomeCompleto}</td>
        </tr>
        <tr>
          <th>Cpf:</th>
          <td>${cpfSearch}</td>
        </tr>
        <tr>
        <th>Data de nascimento:</th>
        <td>${dataRec}</td>
      </tr>
        <tr>
          <th>Aprovação:</th>
          <td>${dataConcessao && maskDataLaudoImpressao(dataConcessao)}</td>
        </tr>
        <tr>
        <th>Data fim validade:</th>
        <td>${dataFimConcessao
        ? maskDataHistoricoSemHora(dataFimConcessao)
        : " Indeterminado"
      }</td>
      </tr>
      <tr>
      <th>Necessário acompanhante?</th>
      <td>${acompanhante ? "Sim" : "Não"}</td>
    </tr>
      </table>
   <table>
     <tr>
       <th>Classificação:</th>
       <td id="description">${usoIlimitado ? "Deficiência permanente" : "Doente crônico"
      }</td>
     </tr>
     ${deficienciaSelect
        ? `<tr>
             <th>Tipo(s):</th>
             <td id="description">
               ${deficienciaSelect
          .map((item) => {
            const matchedItem = deficiencia.find(
              (itemDeficiencia: any) => {
                return (
                  parseInt(item) === parseInt(itemDeficiencia?.value)
                );
              }
            );
            return matchedItem ? matchedItem.label : "";
          })
          .filter(Boolean)
          .join(", ")}
             </td>
           </tr>`
        : ""
      }
     <tr>
        <th>Qtd. de uso mensal:</th>
        <td>${usoIlimitado ? "Uso ilimitado" : acompanhante ? limite * 2 : limite
      }</td>
      </tr>
      ${valorTratamento &&
      ` <tr>
        <th>Tempo de tratamento:</th>
        <td>${valorTratamento ? valorTratamento : ""} - ${valorTratamento
        ? duracaoTratamento === "1"
          ? "Semana(s)"
          : "Mês(es)"
        : ""
      }</td>
      </tr>`
      }
     ${valorFrequenciaTratamento &&
      `
      <tr>
        <th>Frequência de tratamento:</th>
        <td>${valorFrequenciaTratamento ? valorFrequenciaTratamento : ""} ${valorFrequenciaTratamento && " por Mês"
      }</td>
      </tr>
      `
      }
   </table>
 </div>
    <br>
    <div class="footer">
      <p>Responsável pela aprovação: ${JSON.stringify(
        recoverLoggedUser[0]?.nome
      ).replace(/['"]+/g, "")}</p>
      <p>CRM: _______________</p>
      <br>
      <br><br><br><br><br>
      Para obter o Jaé Gratuidade pela primeira vez, envie sua foto pelo aplicativo Jaé. Baixe o app na Google Play ou na App Store e complete seu cadastro de forma rápida e prática!
      <br>
      <br>
      Se precisar, fale com a Jaé através do 0800 2121 828.
    </div>
  </div>

 
</body>
</html>
    `);
    printWindow.document.close();
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
  };

  // @ts-ignore
  // @ts-ignore
  // @ts-ignore
  // @ts-ignore
  // @ts-ignore
  // @ts-ignore
  return (
    <>
      <PopOverAlert
        handleOpenAlert={handleOpenAlert}
        isOpen={isOpen2}
        status={statusPopOver}
        title={titlePopOver}
        subtitle={subtitlePopOver}
      />

      {!showForm ? (
        <Flex
          direction="column"
          minH="100vh"
          pt={{ sm: "125px", lg: "75px" }}
          position="relative"
          mt={"12px"}
        >
          <Flex direction="column" w={{ base: "100%", md: "100%", xl: "100%" }}>
            <Flex
              direction={"row"}
              alignContent={"center"}
              justifySelf={"center"}
            //visibility={viewElements ? "hidden" : "visible"}
            >
              <InputField
                ////onPaste={handlePaste}
                isRequired={true}
                ml={"25px"}
                w="200px"
                h="50px"
                id="cpf"
                label="CPF"
                value={cpfSearch}
                onChange={handleChangeMask}
                onKeyDown={handleKeyDown}
              />
              <InputField
                ////onPaste={handlePaste}
                isRequired={true}
                ml={"25px"}
                type="number"
                w="200px"
                h="50px"
                id="Nº CNS"
                label="Nº CNS"
                value={numeroCns}
                onChange={handleValorCadSus}
                onKeyDown={handleKeyDown}
              />

              <InputField
                ////onPaste={handlePaste}
                isRequired={true}
                ml={"25px"}
                w="350px"
                h="50px"
                id="nome"
                label="Nome"
                value={nomeUsuario}
                onKeyDown={handleKeyDown}
                onChange={(e: {
                  target: { value: React.SetStateAction<string> };
                }) => setNomeUsuario(e.target.value)}
              />

              {/* <InputField
                ////onPaste={handlePaste}
                isRequired={true}
                ml={"25px"}
                w="350px"
                h="50px"
                id="nomeMae"
                label="Nome da Mãe"
                value={nomeMae}
                onKeyDown={handleKeyDown}
                onChange={(e: {
                  target: { value: React.SetStateAction<string> };
                }) => setNomeMae(e.target.value)}
              /> */}

              <IconButton
                mt={"30px"}
                ml={"25px"}
                aria-label="share"
                w="40px"
                h="40px"
                variant="brand"
                borderRadius="20%"
                onClick={onClickPesquisar}
                isLoading={loading}
              >
                <Icon w="14px" h="14px" as={IoSearch} color="white" />
              </IconButton>

              <IconButton
                mt={"30px"}
                ml={"25px"}
                aria-label="share"
                w="40px"
                h="40px"
                variant="brand"
                borderRadius="20%"
                onClick={onClickLimparFiltros}
              >
                <Icon w="14px" h="14px" as={IoCloseCircle} color="white" />
              </IconButton>
            </Flex>
            <Box
              // overflowX="hidden"
              // overflowY={usuariosPesquisa.length > 7 ? "scroll" : "hidden"}
              maxW="100vw"
              h={"490px"}
              whiteSpace="nowrap"
              pb="17px"
              visibility={!viewElements ? "visible" : "hidden"}
            >
              <TableContainer
                visibility={usuariosPesquisa.length > 0 ? "visible" : "hidden"}
                width={"100%"}
                alignSelf={"left"}
                borderBottomStartRadius={"12px"}
              >
                <Table variant="striped" colorScheme="gray">
                  <Thead>
                    <Tr>
                      <Th
                        width={"370px"}
                        style={{
                          maxWidth: "370px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Nome
                      </Th>
                      <Th
                        width={"262px"}
                        style={{
                          minWidth: "262px",
                          maxWidth: "262px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Nome da mãe
                      </Th>
                      <Th width={"190px"}>Dt Nascimento</Th>
                      <Th width={"262px"}>Documento</Th>
                      <Th></Th>
                      <Th></Th>
                    </Tr>
                  </Thead>
                </Table>
              </TableContainer>

              <Flex
                direction="column"
                width={{ xl: "100%", md: "100%", lg: "100%" }}
              >
                <InfiniteScroll
                  dataLength={usuariosPesquisa.length}
                  next={fetchMoreData}
                  hasMore={true}
                  loader={
                    <Flex
                      justify="center"
                      px="10px"
                      pt="5px"
                      mb="25px"
                      mt="20px"
                      alignItems={"center"}
                      justifySelf={"center"}
                    >
                      {!hasMore ? (
                        <Text color={"black"} fontSize="lg" fontWeight="300">
                          {usuariosPesquisa.length > 0 &&
                            "Todos os dados carregados"}
                        </Text>
                      ) : (
                        usuariosPesquisa.length > 0 && (
                          <Flex>
                            <Button
                              variant="action"
                              px="24px"
                              fontSize="sm"
                              fontWeight="700"
                              isLoading={isLoading}
                              disabled={hasMore ? false : true}
                              onClick={() => fetchMoreData()}
                            >
                              {hasMore
                                ? "Carregar mais dados..."
                                : "Não há mais dados"}
                            </Button>
                          </Flex>
                        )
                      )}
                    </Flex>
                  }
                >
                  <TableContainer
                    width={"100%"}
                    alignSelf={"left"}
                    borderBottomStartRadius={"12px"}
                    style={{ overflowY: "scroll", maxHeight: "500px" }}
                  >
                    <Table variant="striped" colorScheme="gray">
                      <Tbody>
                        {usuariosPesquisa.map((row) => {
                          return (
                            <Tr>
                              <Td
                                width={row.nome.length < 13 ? "370px" : "370px"}
                                style={{
                                  maxWidth:
                                    row.nome.length < 13 ? "370px" : "370px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {row.nome}
                              </Td>
                              <Td
                                width={"262px"}
                                style={{
                                  minWidth: "262px",
                                  maxWidth: "262px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {row.nomeMae}
                              </Td>
                              <Td width={"190px"}>
                                {row.dataNascimento &&
                                  maskDataInfo(
                                    row.dataNascimento + "T00:00:00"
                                  )}
                              </Td>
                              <Td width={"262px"}>
                                {" "}
                                {row.tipoDocumento.codigo === 4
                                  ? maskOnlyNumbers(row.numeroDocumento)
                                  : row.tipoDocumento.codigo === 1 ||
                                    row.tipoDocumento.codigo === 2
                                    ? maskCaracterEspecial(
                                      maskCpfCnpj(row.numeroDocumento)
                                    )
                                    : maskOnlyNumbers(row.numeroDocumento)}
                              </Td>
                              <Td></Td>
                              <Td>
                                {" "}
                                {isEmpty(row?.dataCancelamento) ? (
                                  <Button
                                    variant="action"
                                    px="24px"
                                    fontSize="sm"
                                    fontWeight="700"
                                    onClick={() => confirmarAtendimento(row)}
                                  >
                                    Iniciar atendimento{" "}
                                  </Button>
                                ) : (
                                  <Text
                                    fontSize="sm"
                                    color={"red"}
                                    fontWeight="700"
                                  >
                                    Conta cancelada
                                  </Text>
                                )}
                              </Td>
                            </Tr>
                          );
                        })}
                      </Tbody>
                    </Table>
                  </TableContainer>
                </InfiniteScroll>
              </Flex>
            </Box>
          </Flex>
        </Flex>
      ) : null}

      {showForm && (
        <>
          {protocolo ?? ticketGerado ? (
            <Flex
              direction="column"
              visibility={viewElements ? "visible" : "hidden"}
              id="fotoElementoUsuario"
              mt={{
                xl: "-0px",
              }}
              ml={{
                base: "22px",
                md: "-48px",
                xl: "-103px",
              }}
              style={{
                position: "fixed",
                top: "8%",
                left: "57%",
                width: "26%",
                transform: "translate(-50%, -50%)",
                padding: "20px",
                zIndex: 9999,
              }}
            >
              <Text color={textColorPrimary} fontSize={"16px"}>
                Protocolo:
              </Text>
              <Text
                color={textColorPrimary}
                fontSize={"20px"}
                fontWeight={"700"}
              >
                {protocoloId ?? protocolo}
              </Text>
            </Flex>
          ) : null}
          <Flex
            direction="column"
            visibility={!IsEmpty(dataUser) ? "visible" : "hidden"}
            id="fotoElementoUsuario2"
            mt={{
              //small: "8px",
              base: "-2px",
              md: "8px",
              xl: "-23px",
            }}
            style={{
              position: "fixed",
              top: "10.4%",
              left: "74%",
              width: "26%",
              transform: "translate(-50%, -50%)",
              padding: "20px",
              zIndex: 9999,
            }}
          ></Flex>
          <Flex
            direction="row"
            pt={{ sm: "125px", lg: "75px" }}
            justifyContent="space-between"
            position="relative"
            mt={"12px"}
          >
            <Button
              variant="darkBrand"
              fontSize="sm"
              borderRadius="16px"
              p="25px"
              leftIcon={<MdYoutubeSearchedFor size="20px" />}
              onClick={() => {
                cleanFields();
              }}
            >
              Nova Busca
            </Button>

            <Button
              variant="solid"
              colorScheme="red"
              fontSize="sm"
              borderRadius="16px"
              p="25px"
              isDisabled={!temGratuidade ? true : false}
              isLoading={loading}
              leftIcon={<MdOutlineClear size="20px" />}
              onClick={() => {
                //cancelarGratuidade();
                setIsCancelOpen(true);
              }}
            >
              Cancelar gratuidade
            </Button>
            <Modal
              isOpen={isCancelOpen}
              onClose={() => setIsCancelOpen(false)}
              isCentered
              size={"xl"}
            >
              <ModalOverlay />
              <ModalContent alignSelf={"center"}>
                <ModalHeader>Revogar gratuidade</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <Text>
                    Deseja revogar o benefício da gratuidade de{" "}
                    <b>{nomeUsuario || nomeCompleto} </b>?
                  </Text>
                  <Text
                    color={textColor}
                    fontSize="md"
                    fontWeight="300"
                    display="flex"
                    alignItems="center"
                    mt={1}
                  >
                    A partir deste momento não poderá mais ser utilizado o
                    benefício da gratuidade no transporte.
                  </Text>
                </ModalBody>

                <ModalFooter>
                  <Button
                    variant="solid"
                    colorScheme="red"
                    mr={3}
                    onClick={() => {
                      cancelarGratuidade();
                      setIsCancelOpen(false);
                    }}
                  >
                    Sim
                  </Button>
                  <Button
                    variant="light"
                    mr={3}
                    onClick={() => setIsCancelOpen(false)}
                  >
                    Não
                  </Button>
                </ModalFooter>
              </ModalContent>
            </Modal>
          </Flex>
          <Flex
            direction="column"
            minH="100vh"
            align="center"
            pt={{ sm: "125px", lg: "20px" }}
            position="relative"
          >
            <Image
              src={
                "https://io.billingpay.com.br/bp/img/atendimento/gratuidades/pneBanner.png"
              }
              w="100%"
              position="absolute"
              opacity="0%"
              h="45vh"
              objectFit="cover"
              borderRadius="30px"
              me="40px"
              ml="40px"
              mr="30px"
            />

            <Tabs
              variant="unstyled"
              mt={{ base: "60px", md: "0px" }}
              zIndex="0"
              display="flex"
              flexDirection="column"
            >
              <TabList
                display="flex"
                alignItems="center"
                alignSelf="center"
                justifySelf="center"
              >
                <Tab
                  ref={formTab}
                  w={{ sm: "90px", md: "200px", lg: "200px" }}
                  onClick={() => {
                    setActiveBullets({
                      form: true,
                      rules: false,
                      regras: false,
                      media: false,
                      cartao: false,
                      validation: false,
                    });
                  }}
                >
                  <Flex
                    direction="column"
                    justify="center"
                    align="center"
                    position="relative"
                    _before={{
                      content: "''",
                      width: { sm: "90px", md: "200px", lg: "200px" },
                      height: "3px",
                      bg: activeBullets.rules ? "#5340ff" : "#fff",
                      left: { sm: "12px", md: "40px" },
                      top: {
                        sm: activeBullets.form ? "6px" : "4px",
                        md: null,
                      },
                      position: "absolute",
                      bottom: activeBullets.form ? "40px" : "38px",
                      transition: "all .3s ease",
                    }}
                  >
                    <Box
                      zIndex="1"
                      border="2px solid"
                      borderColor="#fff"
                      bg={
                        activeBullets.form
                          ? "linear-gradient(135deg, #fff 0%, #1bd103 100%)"
                          : "linear-gradient(135deg, #eeeeee 0%, #aaaaaa 100%)"
                      }
                      w="16px"
                      h="16px"
                      mb="8px"
                      borderRadius="50%"
                    />
                    <Text
                      color={activeBullets.form ? "black" : "gray.800"}
                      fontWeight={activeBullets.form ? "bold" : "normal"}
                      display={{ sm: "none", md: "block" }}
                      fontSize="lg"
                    >
                      Cadastro
                    </Text>
                  </Flex>
                </Tab>

                <Tab
                  ref={rulesTab}
                  w={{ sm: "90px", md: "200px", lg: "200px" }}
                  onClick={() => {
                    if (
                      unidadesAtendimento === null ||
                      unidadesAtendimento === undefined ||
                      nomeMae === "" ||
                      nomeMae === null ||
                      isEmpty(cep || cepUserNovo)
                    ) {
                      formTab.current.click();
                      showPopOver(
                        "warning",
                        "Ops...",
                        "Campos obrigatórios não podem ser nulos! Preencha e salve o cadastro."
                      );
                      setActiveBullets({
                        form: true,
                        rules: false,
                        regras: false,
                        media: false,
                        cartao: false,
                        validation: false,
                      });
                    } else {
                      setActiveBullets({
                        form: true,
                        rules: true,
                        regras: false,
                        media: false,
                        cartao: false,
                        validation: false,
                      });

                      // validaUnidadeAtendimento();
                    }
                  }}
                // isDisabled={
                //   (unidadesAtendimento === null ||
                //     unidadesAtendimento === undefined) &&
                //   (laudoStatus === false || idLaudo === 0)
                //     ? true
                //     : false
                // }
                >
                  <Flex
                    direction="column"
                    justify="center"
                    align="center"
                    position="relative"
                    _before={{
                      content: "''",
                      width: { sm: "90px", md: "200px", lg: "200px" },
                      height: "3px",
                      bg: activeBullets.regras ? "#5340ff" : "#fff",
                      left: { sm: "12px", md: "30px" },
                      top: "6px",
                      position: "absolute",
                      bottom: activeBullets.rules ? "40px" : "38px",
                      transition: "all .3s ease",
                    }}
                  >
                    <Box
                      zIndex="1"
                      border="2px solid"
                      borderColor="#fff"
                      bg={
                        activeBullets.rules
                          ? "linear-gradient(135deg, #fff 0%, #1bd103 100%)"
                          : "linear-gradient(135deg, #eeeeee 0%, #aaaaaa 100%)"
                      }
                      w="16px"
                      h="16px"
                      mb="8px"
                      borderRadius="50%"
                    />
                    <Text
                      color={activeBullets.rules ? "black" : "gray.800"}
                      fontWeight={activeBullets.rules ? "bold" : "normal"}
                      display={{ sm: "none", md: "block" }}
                      fontSize="lg"
                    >
                      Laudo
                    </Text>
                  </Flex>
                </Tab>
                <Tab
                  ref={regrasTab}
                  w={{ sm: "90px", md: "200px", lg: "200px" }}
                  onClick={() => {
                    regrasTab.current.click();
                    setActiveBullets({
                      form: true,
                      rules: true,
                      regras: true,
                      media: false,
                      cartao: false,
                      validation: false,
                    });
                    validaUnidadeAtendimento();
                  }}
                  isDisabled={
                    (unidadesAtendimento === null ||
                      unidadesAtendimento === undefined) &&
                      (laudoStatus === false || idLaudo === 0)
                      ? true
                      : false
                  }
                >
                  <Flex
                    direction="column"
                    justify="center"
                    align="center"
                    position="relative"
                    _before={{
                      content: "''",
                      width: { sm: "90px", md: "200px", lg: "200px" },
                      height: "3px",
                      bg: activeBullets.media ? "#5340ff" : "#fff",
                      left: { sm: "12px", md: "52px" },
                      top: "6px",
                      position: "absolute",
                      bottom: activeBullets.regras ? "40px" : "38px",
                      transition: "all .3s ease",
                    }}
                  >
                    <Box
                      zIndex="1"
                      border="2px solid"
                      borderColor="#fff"
                      bg={
                        activeBullets.regras
                          ? "linear-gradient(135deg, #fff 0%, #1bd103 100%)"
                          : "linear-gradient(135deg, #eeeeee 0%, #aaaaaa 100%)"
                      }
                      w="16px"
                      h="16px"
                      mb="8px"
                      borderRadius="50%"
                    />
                    <Text
                      color={activeBullets.regras ? "black" : "gray.800"}
                      fontWeight={activeBullets.regras ? "bold" : "normal"}
                      display={{ sm: "none", md: "block" }}
                      fontSize="lg"
                    >
                      Regras de uso{" "}
                    </Text>
                  </Flex>
                </Tab>
                <Tab
                  ref={mediaTab}
                  w={{ sm: "90px", md: "200px", lg: "200px" }}
                  onClick={() => {
                    if (
                      unidadesAtendimento === null ||
                      unidadesAtendimento === undefined ||
                      laudoStatus === false ||
                      idLaudo === 0 ||
                      isEmpty(nomeMae) ||
                      isEmpty(cep || cepUserNovo)
                    ) {
                      formTab.current.click();
                      showPopOver(
                        "warning",
                        "Ops...",
                        "Campos obrigatórios não podem ser nulos!"
                      );
                      setActiveBullets({
                        form: true,
                        rules: false,
                        regras: false,
                        media: false,
                        cartao: false,
                        validation: false,
                      });
                    } else {
                      mediaTab.current.click();

                      setActiveBullets({
                        form: true,
                        rules: true,
                        regras: true,
                        media: true,
                        cartao: false,
                        validation: false,
                      });
                      validaUnidadeAtendimento();
                    }
                  }}
                  isDisabled={
                    (unidadesAtendimento === null ||
                      unidadesAtendimento === undefined) &&
                      (laudoStatus === false || idLaudo === 0)
                      ? true
                      : false
                  }
                >
                  <Flex
                    direction="column"
                    justify="center"
                    align="center"
                    position="relative"
                    _before={{
                      content: "''",
                      width: { sm: "90px", md: "200px", lg: "200px" },
                      height: "3px",
                      bg: activeBullets.cartao ? "#5340ff" : "#fff",
                      left: { sm: "12px", md: "65px" },
                      top: "6px",
                      position: "absolute",
                      bottom: activeBullets.media ? "40px" : "38px",
                      transition: "all .3s ease",
                    }}
                  >
                    <Box
                      zIndex="1"
                      border="2px solid"
                      borderColor="#fff"
                      bg={
                        activeBullets.media
                          ? "linear-gradient(135deg, #fff 0%, #1bd103 100%)"
                          : "linear-gradient(135deg, #eeeeee 0%, #aaaaaa 100%)"
                      }
                      w="16px"
                      h="16px"
                      mb="8px"
                      borderRadius="50%"
                    />
                    <Text
                      color={activeBullets.media ? "black" : "gray.800"}
                      fontWeight={activeBullets.media ? "bold" : "normal"}
                      display={{ sm: "none", md: "block" }}
                      fontSize="lg"
                    >
                      Biometria facial
                    </Text>
                  </Flex>
                </Tab>
                <Tab
                  ref={cartaoTab}
                  w={{ sm: "90px", md: "200px", lg: "200px" }}
                  onClick={() => {
                    if (laudoStatus === false || !dataUser === null) {
                      formTab.current.click();
                      showPopOver(
                        "warning",
                        "Ops...",
                        "Campos obrigatórios não podem ser nulos! "
                      );
                      setActiveBullets({
                        form: true,
                        rules: false,
                        regras: false,
                        media: false,
                        cartao: false,
                        validation: false,
                      });
                    } else {
                      cartaoTab.current.click();
                      setActiveBullets({
                        form: true,
                        rules: true,
                        regras: true,
                        media: true,
                        cartao: true,
                        validation: false,
                      });
                      validaUnidadeAtendimento();
                    }
                  }}
                  isDisabled={
                    (unidadesAtendimento === null ||
                      unidadesAtendimento === undefined) &&
                      (laudoStatus === false || idLaudo === 0)
                      ? true
                      : false
                  }
                >
                  <Flex
                    direction="column"
                    justify="center"
                    align="center"
                    position="relative"
                    _before={{
                      content: "''",
                      width: { sm: "90px", md: "200px", lg: "200px" },
                      height: "3px",
                      bg: activeBullets.validation ? "#5340ff" : "#fff",
                      left: { sm: "12px", md: "60px" },
                      top: "6px",
                      position: "absolute",
                      bottom: activeBullets.cartao ? "40px" : "38px",
                      transition: "all .3s ease",
                    }}
                  >
                    <Box
                      zIndex="1"
                      border="2px solid"
                      borderColor="#fff"
                      bg={
                        activeBullets.cartao
                          ? "linear-gradient(135deg, #fff 0%, #1bd103 100%)"
                          : "linear-gradient(135deg, #eeeeee 0%, #aaaaaa 100%)"
                      }
                      w="16px"
                      h="16px"
                      mb="8px"
                      borderRadius="50%"
                    />
                    <Text
                      color={activeBullets.cartao ? "black" : "gray.800"}
                      fontWeight={activeBullets.cartao ? "bold" : "normal"}
                      display={{ sm: "none", md: "block" }}
                      fontSize="lg"
                    >
                      Solicitar cartão
                    </Text>
                  </Flex>
                </Tab>
                <Tab
                  ref={validationTab}
                  w={{ sm: "90px", md: "200px", lg: "200px" }}
                  onClick={() => {
                    validationTab.current.click();
                    setActiveBullets({
                      form: true,
                      rules: true,
                      regras: true,
                      media: true,
                      cartao: true,
                      validation: true,
                    });
                  }}
                >
                  <Flex
                    direction="column"
                    justify="center"
                    align="center"
                    position="relative"
                  >
                    <Box
                      zIndex="1"
                      border="2px solid"
                      borderColor="#fff"
                      bg={
                        activeBullets.validation
                          ? "linear-gradient(135deg, #fff 0%, #1bd103 100%)"
                          : "linear-gradient(135deg, #eeeeee 0%, #aaaaaa 100%)"
                      }
                      w="16px"
                      h="16px"
                      mb="8px"
                      borderRadius="50%"
                    />
                    <Text
                      color={activeBullets.validation ? "black" : "gray.800"}
                      fontWeight={activeBullets.validation ? "bold" : "normal"}
                      display={{ sm: "none", md: "block" }}
                      fontSize="lg"
                    >
                      Finalizar
                    </Text>
                  </Flex>
                </Tab>
              </TabList>
              <TabPanels mt="24px" maxW={{ md: "90%", lg: "100%" }} mx="auto">
                <TabPanel
                  w={{ sm: "330px", md: "700px", lg: "850px" }}
                  p="0px"
                  mx="auto"
                >
                  {!IsEmpty(dataUser) && !IsEmpty(laudo) ? (
                    <Card p="30px" mb="5">
                      <Flex flexDirection="row">
                        <Icon
                          as={MdFingerprint}
                          color={textColor}
                          w="20px"
                          h="18px"
                        />
                        <Text
                          color={textColor}
                          fontSize="sm"
                          fontWeight="700"
                          lineHeight="100%"
                          mt={1}
                          ml={2}
                        >
                          {laudo?.desativarBiometriaFacial === true
                            ? "  Biometria desativada"
                            : "  Biometria ativada"}
                        </Text>
                        <Icon
                          as={MdOutlinePersonAddAlt1}
                          color={textColor}
                          w="20px"
                          h="18px"
                          ml={6}
                        />
                        <Text
                          color={textColor}
                          fontSize="sm"
                          fontWeight="700"
                          lineHeight="100%"
                          mt={1}
                          ml={2}
                        >
                          {laudo?.necessitaAcompanhante === true
                            ? "  Possui acompanhante"
                            : "  Não possui acompanhante"}
                        </Text>
                      </Flex>
                    </Card>
                  ) : null}

                  <Card p="30px">
                    <Text
                      color={textColor}
                      fontSize="2xl"
                      fontWeight="700"
                      mb="20px"
                    >
                      Dados Pessoais
                    </Text>
                    <Flex direction="column" w="100%">
                      <SimpleGrid columns={{ base: 1, md: 2 }} gap="20px">
                        <Stack direction="column" gap="20px">
                          <InputField
                            ////onPaste={handlePaste}
                            mb="0px"
                            id="nome"
                            value={formatarNomeCompleto(
                              nomeCompleto.replace(
                                /[^a-zA-ZáàâãäéèêëíìîïóòôõöúùûüçñÁÀÂÃÄÉÈÊËÍÌÎÏÓÒÔÕÖÚÙÛÜÇÑ\s]/g,
                                ""
                              )
                            )}
                            isDisabled={!isEmpty(dataUser) ? true : false}
                            onChange={(e: {
                              target: {
                                value: React.SetStateAction<string>;
                              };
                            }) => setNomeCompleto(e.target.value)}
                            placeholder="Nome Completo"
                            label="Nome Completo *"
                          />
                          <InputField
                            ////onPaste={handlePaste}
                            mb="26px"
                            id="cpf"
                            label="CPF*"
                            value={maskCpfCnpj(cpfSearch)}
                            onChange={handleChangeMask}
                            onKeyDown={handleKeyDown}
                          //disabled={cpfSearch || dataUser[0]?.numeroDocumento}
                          />

                          <SimpleGrid
                            columns={{ base: 1, md: 1 }}
                            gap="20px"
                            mb={"15px"}
                            mt={"-25px"}
                          >
                            <Tooltip
                              mb={"19px"}
                              label="
Nome Social é o nome que uma pessoa trans ou não-binária escolhe usar, refletindo sua identidade de gênero, mesmo que seja diferente do nome em documentos legais."
                            >
                              <Flex direction={"row"}>
                                <FormLabel
                                  mb="20px"
                                  htmlFor="nomeSocial"
                                  fontSize="sm"
                                  color={textColorPrimary}
                                  fontWeight="bold"
                                  _hover={{ cursor: "pointer" }}
                                >
                                  Nome social
                                </FormLabel>
                                <Icon
                                  as={MdContactSupport}
                                  color={iconColor}
                                  //onClick={}
                                  w="24px"
                                  h="24px"
                                />
                              </Flex>
                            </Tooltip>
                            <InputField
                              ////onPaste={handlePaste}
                              mb="-20px"
                              mt="-22px"
                              id="nome"
                              value={nomeSocial}
                              onChange={(e: {
                                target: {
                                  value: React.SetStateAction<string>;
                                };
                              }) => setNomeSocial(e.target.value)}
                              placeholder="Nome Social"
                            // label="Nome Social"
                            />
                          </SimpleGrid>

                          <InputField
                            ////onPaste={handlePaste}
                            mb="0px"
                            id="nomeMae"
                            value={nomeMae}
                            onChange={(e: {
                              target: {
                                value: React.SetStateAction<string>;
                              };
                            }) => setNomeMae(e.target.value)}
                            placeholder="Nome mãe"
                            label="Nome mãe *"
                          />
                        </Stack>
                        <Stack direction="column" gap="20px">
                          <InputField
                            //onPaste={handlePaste}
                            mb="0px"
                            id="email"
                            value={email}
                            disabled={
                              usuarios[0]?.perfis.some((perfil: string) =>
                                perfisDesejadosDataNascimento.includes(perfil)
                              ) || isEmpty(dataUser)
                                ? false
                                : true
                            }
                            onChange={(e: {
                              target: {
                                value: React.SetStateAction<string>;
                              };
                            }) => setEmail(e.target.value)}
                            placeholder="Email"
                            label="Email"
                          />
                          <InputField
                            //onPaste={handlePaste}
                            mb="0px"
                            id="data"
                            label="Data nascimento *"
                            isDisabled={
                              isEmpty(dataUser) ||
                                usuarios[0]?.perfis.some((perfil: string) =>
                                  perfisDesejadosDataNascimento.includes(perfil)
                                )
                                ? false
                                : true
                            }
                            value={dataRec}
                            maxLength={10}
                            onChange={(e: {
                              target: {
                                value: React.SetStateAction<string>;
                              };
                            }) => {
                              setDataRec(maskDatainfor(e.target.value));
                              if (e.target.value.length === 10) {
                                validateFormData(e.target.value);
                              }
                            }}
                          />

                          <InputField
                            //onPaste={handlePaste}
                            mb="0px"
                            id="celular"
                            value={celular}
                            maxLength="15"
                            disabled={
                              usuarios[0]?.perfis.some((perfil: string) =>
                                perfisDesejadosDataNascimento.includes(perfil)
                              ) || isEmpty(dataUser)
                                ? false
                                : true
                            }
                            onChange={(e: {
                              target: {
                                value: React.SetStateAction<string>;
                              };
                            }) => setCelular(maskCelular(e.target.value))}
                            placeholder="Celular"
                            label="Telefone *"
                          />
                        </Stack>
                      </SimpleGrid>
                      {["Dev", "Partiu"].some((env) =>
                        window.config.tenant.includes(env)
                      ) && (
                          <Flex direction="column" mb="30px" mt="20px" ms="10px">
                            <Text
                              fontSize="sm"
                              fontWeight="700"
                              color={textColor}
                              mb={"10px"}
                              ml={"-10px"}
                            >
                              Operadora
                            </Text>
                            <Select
                              ml={"-10px"}
                              mt={"0px"}
                              required={true}
                              id="operadoras"
                              name="operadoras"
                              height="44px"
                              fontSize="sm"
                              fontWeight="500"
                              borderRadius="16px"
                              defaultValue="0"
                              value={idOperadora ?? null}
                              isDisabled={idOperadora && !IsEmpty(dataUser)}
                              onChange={(e: any) => {
                                setIdOperadora(Number(e.target.value));
                              }}
                            >
                              <option value="0">Selecione a operadora</option>
                              {operadora
                                .filter((item: any) => item?.cliente?.nome)
                                .map((option: any) => (
                                  <option key={option.id} value={option.id}>
                                    {option.cliente.nome}
                                  </option>
                                ))}
                            </Select>
                          </Flex>
                        )}
                      <Divider mb="20px" mt={"35px"} />
                      <Stack direction="column" gap="20px">
                        <Text
                          color={textColor}
                          fontSize="2xl"
                          fontWeight="700"
                          mb="20px"
                        >
                          Dados CNS
                        </Text>
                      </Stack>
                      <SimpleGrid columns={{ base: 1, md: 1 }} gap="20px">
                        <InputField
                          ////onPaste={handlePaste}
                          width={"200px"}
                          id="cadsus"
                          value={numeroCns}
                          onChange={(e: {
                            target: { value: React.SetStateAction<string> };
                          }) => setNumeroCns(e.target.value)}
                          placeholder="Nº CNS"
                          label="Nº CNS"
                        // disabled={
                        //   cadSus !== null &&
                        //   cadSus !== "" &&
                        //   cadSus.length === 15
                        // }
                        />
                        <SimpleGrid
                          columns={{ base: 1, md: 1 }}
                          gap="20px"
                          mb={"25px"}
                          mt={"-25px"}
                        >
                          <FormLabel
                            mb="-10px"
                            htmlFor="grupos"
                            fontSize="sm"
                            color={textColorPrimary}
                            fontWeight="bold"
                            _hover={{ cursor: "pointer" }}
                          >
                            Unidade de atendimento *
                          </FormLabel>
                          <AsyncSelect<
                            AtendimentosOption,
                            true,
                            GroupBase<AtendimentosOption>
                          >
                            isMulti
                            name="uap"
                            className="selectAsync"
                            options={unidades}
                            value={unidadesAtendimento}
                            selectedOptionColor="red"
                            onChange={(e) => handleChangeUnidades1(e)}
                            placeholder="Digite o nome da unidade..."
                            closeMenuOnSelect={true}
                            noOptionsMessage={({ inputValue }) =>
                              !inputValue
                                ? "Sem unidade"
                                : "Não foi encontrada nenhuma unidade pela busca"
                            }
                            size="md"
                            chakraStyles={{
                              dropdownIndicator: (provided) => ({
                                ...provided,
                                bg: "transparent",
                                p: 0,
                                w: 6,
                                mx: 2,
                                color: "grey",
                                cursor: "inherit",
                              }),
                              indicatorSeparator: () => ({
                                display: "none",
                              }),
                            }}
                            loadOptions={(inputValue, callback) => {
                              const values = unidades.filter((i) =>
                                i.label
                                  .toLowerCase()
                                  .includes(inputValue.toLowerCase())
                              );
                              callback(values);
                            }}
                          />
                        </SimpleGrid>
                      </SimpleGrid>
                      <Divider mb="20px" />
                      <Text
                        color={textColor}
                        fontSize="2xl"
                        fontWeight="700"
                        mb="20px"
                      >
                        Endereço
                      </Text>
                      <SimpleGrid columns={{ base: 1, md: 3 }} gap="20px">
                        <InputField
                          //onPaste={handlePaste}
                          isRequired={true}
                          maxLength="10"
                          mb="15px"
                          me="0px"
                          id="cep"
                          label="Cep *"
                          value={cep}
                          onChange={(e: { target: { value: any } }) => {
                            if (e.target.value.length === 8) {
                              handleFocusChange(e.target.value);
                            }
                            setCep(maskCep(e.target.value));
                          }}
                        />
                      </SimpleGrid>

                      {loadingCep ? (
                        "Carregando..."
                      ) : (
                        <div>
                          {IsNotEmpty(cep) && (
                            <SimpleGrid mt="30px" gap="20px">
                              <InputField
                                //onPaste={handlePaste}
                                mb="0px"
                                disabled
                                id="logradouro"
                                value={logradouro}
                                onChange={(e: {
                                  target: {
                                    value: React.SetStateAction<string>;
                                  };
                                }) => setLogradouro(e.target.value)}
                                placeholder="Logradouro"
                                label="Logradouro *"
                              />
                            </SimpleGrid>
                          )}
                          {IsNotEmpty(cep) && (
                            <SimpleGrid
                              columns={{ base: 1, md: 2 }}
                              mt="30px"
                              gap="20px"
                            >
                              <Stack direction="column" gap="20px">
                                <InputField
                                  //onPaste={handlePaste}
                                  mb="0px"
                                  id="numero"
                                  value={numero}
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>
                                  ) => {
                                    const onlyNumbers = e.target.value.replace(
                                      /\D/g,
                                      ""
                                    );
                                    setNumero(onlyNumbers);
                                  }}
                                  placeholder="Número"
                                  label="Número *"
                                />
                                <InputField
                                  //onPaste={handlePaste}
                                  mb="0px"
                                  id="cidade"
                                  disabled
                                  value={cidade}
                                  onChange={(e: {
                                    target: {
                                      value: React.SetStateAction<string>;
                                    };
                                  }) => setCidade(e.target.value)}
                                  placeholder="Cidade"
                                  label="Cidade *"
                                />
                              </Stack>
                              <Stack direction="column" gap="20px">
                                <InputField
                                  //onPaste={handlePaste}
                                  mb="0px"
                                  id="bairro"
                                  disabled
                                  value={bairro}
                                  onChange={(e: {
                                    target: {
                                      value: React.SetStateAction<string>;
                                    };
                                  }) => setBairro(e.target.value)}
                                  placeholder="Bairro"
                                  label="Bairro *"
                                />
                                <Flex direction="column">
                                  <FormLabel
                                    ms="10px"
                                    htmlFor="estado"
                                    fontSize="sm"
                                    color={textColorPrimary}
                                    fontWeight="bold"
                                    _hover={{ cursor: "pointer" }}
                                  >
                                    Estado *
                                  </FormLabel>
                                  <Select
                                    id="estado"
                                    disabled
                                    fontSize="sm"
                                    value={estado}
                                    variant="main"
                                    h="44px"
                                    maxH="44px"
                                    me="20px"
                                    onChange={(e: {
                                      target: {
                                        value: React.SetStateAction<string>;
                                      };
                                    }) => setEstado(e.target.value)}
                                  >
                                    <option value="">Selecione</option>
                                    {ufSelect.map((option) => (
                                      <option value={option.value}>
                                        {option.label}
                                      </option>
                                    ))}
                                  </Select>
                                </Flex>
                              </Stack>
                            </SimpleGrid>
                          )}
                          {IsNotEmpty(cep) && (
                            <SimpleGrid
                              columns={{ md: 1 }}
                              mt="30px"
                              gap="20px"
                            >
                              <Stack direction="column" gap="20px">
                                <InputField
                                  //onPaste={handlePaste}
                                  mb="0px"
                                  id="referencia"
                                  value={pontoReferencia}
                                  onChange={(e: {
                                    target: {
                                      value: React.SetStateAction<string>;
                                    };
                                  }) => setPontoReferencia(e.target.value)}
                                  placeholder="Complemento"
                                  label="Complemento"
                                />
                              </Stack>
                            </SimpleGrid>
                          )}
                        </div>
                      )}
                      <Flex justify="space-between" mt="24px">
                        <Button
                          variant="brand"
                          fontSize="sm"
                          borderRadius="16px"
                          p="25px"
                          ms="auto"
                          isDisabled={
                            unidadesAtendimento === null ||
                              unidadesAtendimento === undefined ||
                              IsEmpty(nomeMae) ||
                              isEmpty(cep || cepUserNovo)
                              ? true
                              : false
                          }
                          rightIcon={<MdOutlineDoubleArrow size="20px" />}
                          isLoading={loading}
                          loadingText="Salvando..."
                          onClick={() => {
                            nextPageMedia();
                            if (alterarBiometriaFacial === true) {
                              rulesTab.current.click();
                              setActiveBullets({
                                form: true,
                                rules: true,
                                regras: false,
                                media: false,
                                cartao: false,
                                validation: false,
                              });
                              setAlterarBiometriaFacial(
                                !alterarBiometriaFacial
                              );
                            }
                          }}
                        >
                          {IsEmpty(dataCadastroUser)
                            ? "Salvar cadastro "
                            : "Salvar cadastro"}
                        </Button>
                      </Flex>
                    </Flex>
                  </Card>
                </TabPanel>

                <TabPanel
                  w={{ sm: "330px", md: "700px", lg: "850px" }}
                  p="0px"
                  mx="auto"
                >
                  {algumUsuarioCompativelLaudo ? (
                    <Card p="30px">
                      <Text
                        ref={printRef}
                        color={textColor}
                        fontSize="2xl"
                        fontWeight="700"
                        mb="20px"
                      >
                        Laudo
                      </Text>

                      <Flex direction="column" w="100%">
                        <Stack direction="row" mb="50px">
                          <RadioGroup
                            ref={printRef}
                            value={value}
                            onChange={(e) => {
                              const selectedValue = e; // O valor do rádio selecionado é passado diretamente

                              if (selectedValue === "2") {
                                // Reseta os valores se 'Deficiência Permanente' estiver selecionado
                                setUsoIlimitado(true);
                                setDuracaoTratamento("");
                                setValorTratamento("");
                                setDuracaoFrequenciaTratamento("");
                                setValorFrequenciaTratamento("");
                                setAcompanhante(false);
                                setBiometria(false);
                                setLimite(0);
                                //setDataFimConcessao("");
                                //setCodigoCid([]);
                                //setObsLaudo("");
                              } else {
                                setUsoIlimitado(false);
                                setDeficienciaSelect([]);
                              }

                              setValue(selectedValue); // Atualiza o estado com o valor selecionado
                            }}
                          >
                            {" "}
                            <Stack direction="row">
                              <Radio value="1">Doente crônico</Radio>
                              <Radio value="2">Deficiência permanente</Radio>
                            </Stack>
                          </RadioGroup>
                        </Stack>
                        {value === "1" && (
                          <Stack direction="row" gap="5px" mt="-10px">
                            <InputField
                              //onPaste={handlePaste}
                              mr="20px"
                              id="duracaoTratamento"
                              maxLength="4"
                              width={"200px"}
                              placeholder="Tempo tratamento"
                              label="Tempo de tratamento *"
                              value={valorTratamento}
                              onChange={(e: {
                                target: {
                                  value: React.SetStateAction<string>;
                                };
                              }) =>
                                setValorTratamento(
                                  maskOnlyNumbers(e.target.value)
                                )
                              }
                            />
                            <Stack width={"100%"}>
                              <Text
                                fontSize="sm"
                                fontWeight="700"
                                mb="20px"
                              ></Text>

                              <Select
                                borderRadius="16px"
                                value={duracaoTratamento}
                                h="44px"
                                fontSize="sm"
                                fontWeight="500"
                                width={"200px"}
                                defaultValue={"1"}
                                onChange={(e: {
                                  target: {
                                    value: React.SetStateAction<string>;
                                  };
                                }) => setDuracaoTratamento(e.target.value)}
                              >
                                <option value="1" selected>
                                  Semana(s)
                                </option>
                                <option value="2">Mês(meses)</option>
                              </Select>
                            </Stack>
                          </Stack>
                        )}
                        {value === "1" && (
                          <Flex
                            direction={"row"}
                            width={"max-content"}
                            justifyContent={"space-between"}
                          >
                            <InputField
                              mr="20px"
                              id="duracaoTratamento"
                              maxLength="4"
                              width={"200px"}
                              placeholder="Frequência tratamento"
                              label="Frequência de tratamento *"
                              value={valorFrequenciaTratamento}
                              onChange={(e: {
                                target: {
                                  value: React.SetStateAction<string>;
                                };
                              }) => {
                                if (Number(e.target.value.valueOf()) < 32) {
                                  setValorFrequenciaTratamento(
                                    maskOnlyNumbers(e.target.value)
                                  );
                                } else {
                                  showPopOver(
                                    "warning",
                                    "Ops...",
                                    "A frequência de tratamento deve ser menor ou igual a 31"
                                  );
                                }
                              }}
                            />
                            <Stack width={"100%"}>
                              <Text
                                fontSize="sm"
                                fontWeight="700"
                                mt={"40px"}
                                mr={"15px"}
                              >
                                /
                              </Text>
                            </Stack>

                            <Stack width={"100%"}>
                              <Text
                                fontSize="sm"
                                fontWeight="700"
                                mb="20px"
                              ></Text>

                              <Select
                                borderRadius="16px"
                                value={duracaoFrequenciaTratamento}
                                h="44px"
                                fontSize="sm"
                                fontWeight="500"
                                width={"200px"}
                                defaultValue={"2"}
                                onChange={(e: {
                                  target: {
                                    value: React.SetStateAction<string>;
                                  };
                                }) =>
                                  setDuracaoFrequenciaTratamento(e.target.value)
                                }
                              >
                                {/* <option value="1" selected>
                                  Semanal
                                </option> */}
                                <option value="2">Mensal</option>
                              </Select>
                            </Stack>
                          </Flex>
                        )}
                        {/* {!usoIlimitado &&
                      <Divider mb="40px" mt={usoIlimitado ? "-20px" : "15px"} />
                     } */}

                        <Flex
                          direction={"column"}
                          justifyContent={"space-between"}
                          mb={"25px"}
                        >
                          <Stack direction={"row"} mb={"25px"}>
                            <Checkbox
                              colorScheme="brandScheme"
                              checked={acompanhante}
                              isChecked={acompanhante}
                              onChange={(e) => {
                                setAcompanhante(e.target.checked);
                                changeAcompanhante(e.target.checked);
                              }}
                            />
                            <Text
                              color={textColor}
                              fontSize="sm"
                              fontWeight="700"
                              display="flex"
                              alignItems="center"
                            >
                              Necessário Acompanhante{" "}
                            </Text>
                          </Stack>

                          <Stack direction={"row"}>
                            <Checkbox
                              colorScheme="brandScheme"
                              checked={
                                menor12Anos(dataRec) === true ? true : biometria
                              }
                              isChecked={
                                menor12Anos(dataRec) === true ? true : biometria
                              }
                              onChange={(e) => setBiometria(e.target.checked)}
                            />
                            <Text
                              color={textColor}
                              fontSize="sm"
                              fontWeight="700"
                              display="flex"
                              alignItems="center"
                            >
                              Desativar Biometria Facial{" "}
                              {menor12Anos(dataRec) === true &&
                                " (Menor de 12 anos)"}
                            </Text>
                          </Stack>
                        </Flex>

                        <SimpleGrid
                          columns={{ base: 1, md: 1 }}
                          gap="20px"
                          mb={"25px"}
                          mt={"8px"}
                        >
                          <FormLabel
                            mb="-10px"
                            htmlFor="grupos"
                            fontSize="sm"
                            color={textColorPrimary}
                            fontWeight="bold"
                            _hover={{ cursor: "pointer" }}
                          >
                            Lista de Cids* (Digite ao menos 3 caracteres para a
                            busca)
                          </FormLabel>
                          <AsyncSelect<CidsOption, true, GroupBase<CidsOption>>
                            isMulti
                            name="escolas"
                            className="selectAsync"
                            options={cids}
                            value={listaCids}
                            selectedOptionColor="red"
                            onChange={(e) => handleChangeCids(e)}
                            placeholder="Digite o nome do CID..."
                            closeMenuOnSelect={true}
                            noOptionsMessage={({ inputValue }) =>
                              !inputValue
                                ? "Sem CID"
                                : "Não foi encontrada nenhum CID pela busca"
                            }
                            size="md"
                            chakraStyles={{
                              dropdownIndicator: (provided) => ({
                                ...provided,
                                bg: "transparent",
                                p: 0,
                                w: 6,
                                mx: 3,
                                color: "grey",
                                cursor: "inherit",
                              }),
                              indicatorSeparator: () => ({
                                display: "none",
                              }),
                            }}
                            loadOptions={(inputValue, callback) => {
                              if (inputValue.length >= 3) {
                                const lowercaseInput = inputValue.toLowerCase();
                                const matchingValues: any[] = [];

                                cids.forEach((item) => {
                                  const lowercaseLabel =
                                    item.label.toLowerCase();
                                  const lowercaseValue = item.value;
                                  if (
                                    lowercaseLabel.includes(lowercaseInput) ||
                                    lowercaseValue.includes(lowercaseInput)
                                  ) {
                                    matchingValues.push(item);
                                  }
                                });

                                callback(matchingValues);
                              } else {
                                // Se o comprimento for menor que 5, não faça nenhuma pesquisa
                                callback([]);
                              }
                            }}
                          />
                        </SimpleGrid>
                        <SimpleGrid
                          columns={{ base: 1, md: 1 }}
                          gap="20px"
                          mb={"25px"}
                        >
                          <FormLabel
                            mb="-10px"
                            htmlFor="grupos"
                            fontSize="sm"
                            color={textColorPrimary}
                            fontWeight="bold"
                            _hover={{ cursor: "pointer" }}
                          >
                            Unidade de realização do tratamento *
                          </FormLabel>
                          <AsyncSelect<
                            AtendimentosOption,
                            true,
                            GroupBase<AtendimentosOption>
                          >
                            name="uap"
                            className="selectAsync"
                            options={unidades}
                            value={unidadesTratamento}
                            selectedOptionColor="red"
                            onChange={(e) => handleChangeUnidades2(e)}
                            placeholder="Digite o nome da unidade onde o tratamento irá realizado..."
                            closeMenuOnSelect={true}
                            noOptionsMessage={({ inputValue }) =>
                              !inputValue
                                ? "Sem unidade"
                                : "Não foi encontrada nenhuma unidade pela busca"
                            }
                            size="md"
                            chakraStyles={{
                              dropdownIndicator: (provided) => ({
                                ...provided,
                                bg: "transparent",
                                p: 0,
                                w: 6,
                                mx: 2,
                                color: "grey",
                                cursor: "inherit",
                              }),
                              indicatorSeparator: () => ({
                                display: "none",
                              }),
                            }}
                            loadOptions={(inputValue, callback) => {
                              const values = unidades.filter((i) =>
                                i.label
                                  .toLowerCase()
                                  .includes(inputValue.toLowerCase())
                              );
                              callback(values);
                            }}
                          />
                        </SimpleGrid>
                        {value === "2" && (
                          <Flex direction={"column"}>
                            <FormLabel
                              mb="-10px"
                              htmlFor="grupos"
                              fontSize="sm"
                              color={textColorPrimary}
                              fontWeight="bold"
                              _hover={{ cursor: "pointer" }}
                            >
                              Tipo deficiência*
                              <Text color={"blue.400"}>
                                Segure o CTRL para selecionar mais de um tipo
                              </Text>
                            </FormLabel>
                            <Select
                              mt={"16px"}
                              mb={"16px"}
                              isRequired={true}
                              id="deficiencia"
                              name="deficiencia"
                              h="144px"
                              fontSize="sm"
                              fontWeight="500"
                              borderRadius="1px"
                              value={deficienciaSelect}
                              onChange={(e) => handleChangeSelectDeficiencia(e)}
                              multiple
                              sx={{
                                option: {
                                  "&:checked": {
                                    backgroundColor: "#007acc", // Cor de fundo ao selecionar
                                    color: "white", // Cor do texto
                                  },
                                },
                                "&[multiple]": {
                                  appearance: "none", // Remove a seta padrão no Chrome, Edge e Safari
                                  MozAppearance: "none", // Remove a seta padrão no Firefox
                                  WebkitAppearance: "none", // Remove a seta padrão no Safari e navegadores baseados em WebKit
                                  background: "transparent", // Certifica-se de que não há fundo que imite a seta
                                  paddingRight: "16px",
                                  overflow: "none", // Ajuste de padding para evitar problemas de espaçamento
                                },
                              }}
                            >
                              {/* <option value="0">Selecione a deficiência</option> */}
                              {deficiencia.map((option: any) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </Select>
                          </Flex>
                        )}
                        <Flex direction={"column"}>
                          <FormLabel
                            mb="2px"
                            htmlFor="grupos"
                            fontSize="sm"
                            color={textColorPrimary}
                            fontWeight="bold"
                            _hover={{ cursor: "pointer" }}
                          >
                            Informações complementares
                          </FormLabel>
                          <TextField
                            id="obs"
                            label=""
                            h="100px"
                            w="100%"
                            maxLength="150"
                            placeholder="Informações complementares. Max 150 caracteres!"
                            value={obsLaudo}
                            onChange={(e: {
                              target: {
                                value: React.SetStateAction<string>;
                              };
                            }) => setObsLaudo(e.target.value)}
                          />
                        </Flex>

                        <Flex justify="space-between" mt="24px">
                          <Button
                            variant="light"
                            fontSize="sm"
                            borderRadius="16px"
                            w={{ base: "128px", md: "148px" }}
                            h="46px"
                            leftIcon={
                              <MdOutlineDoubleArrow
                                size="20px"
                                style={{ rotate: "180deg" }}
                              />
                            }
                            onClick={() => mediaTab.current.click()}
                          >
                            Anterior
                          </Button>

                          {/* <Button
                            variant="brand"
                            fontSize="sm"
                            borderRadius="16px"
                            p="25px"
                            isLoading={loading}
                            disabled={statusSalvarLaudo === true ? true : false}
                            loadingText="Salvando..."
                            onClick={() => nextPageValidations()}
                          >
                            Salvar laudo
                          </Button> */}
                          {/* <Button
                            variant="solid"
                            colorScheme="blue"
                            fontSize="sm"
                            borderRadius="16px"
                            onClick={handlePrint}
                            leftIcon={<MdPrint size="20px" />}
                            p="25px"
                          >
                            Imprimir laudo
                          </Button> */}
                          <Button
                            variant="solid"
                            colorScheme="green"
                            fontSize="sm"
                            isDisabled={
                              unidadesAtendimento === null ||
                                unidadesAtendimento === undefined
                                ? // laudoStatus === false ||
                                // idLaudo === 0
                                true
                                : false
                            }
                            rightIcon={<MdOutlineDoubleArrow size="20px" />}
                            borderRadius="16px"
                            onClick={() => {
                              onChangeModalConfirmacaoAlteracaoLaudoAbrir();
                            }}
                            leftIcon={<MdOutlineEngineering size="20px" />}
                            p="25px"
                          >
                            Salvar laudo e conceder benefício
                          </Button>
                        </Flex>
                      </Flex>
                    </Card>
                  ) : (
                    <Card p="30px">
                      <Flex
                        direction="column"
                        w="100%"
                        align={"center"}
                        mt={"15px"}
                      >
                        <Text
                          color={textColor}
                          fontSize="large"
                          fontWeight="700"
                        >
                          Olá, você não tem permissão para acessar o laudo!
                        </Text>
                      </Flex>
                      <Flex justify="end" mt="24px">
                        <Button
                          variant="light"
                          fontSize="sm"
                          borderRadius="16px"
                          w={{ base: "128px", md: "148px" }}
                          //h="46px"

                          rightIcon={
                            <MdOutlineDoubleArrow
                              size="20px"
                            //style={{ rotate: "180deg" }}
                            />
                          }
                          onClick={() => {
                            mediaTab.current.click();
                          }}
                        >
                          Próximo
                        </Button>
                      </Flex>
                    </Card>
                  )}
                </TabPanel>
                <TabPanel
                  w={{ sm: "330px", md: "700px", lg: "850px" }}
                  p="0px"
                  mx="auto"
                >
                  <Card p="30px">
                    <Flex direction="column" w="100%">
                      <Text
                        color={textColor}
                        fontSize="2xl"
                        fontWeight="700"
                        mb="20px"
                      >
                        Regras de uso{" "}
                        {perfisPermitidosLaudo && " / Impressão de laudo"}
                      </Text>
                    </Flex>
                    {laudoStatus === true ? (
                      <Flex direction="column" w="100%" mb={12} mt={15}>
                        <Text fontSize="sm" fontWeight="300" mr={"15px"} mt={5}>
                          <b>Data da concessão:</b>{" "}
                          {dataConcessao && maskDataHistorico(dataConcessao)}
                        </Text>
                        {limite > 0 ? (
                          <Text
                            fontSize="sm"
                            fontWeight="300"
                            mr={"15px"}
                            mt={5}
                          >
                            <b>Data fim validade:</b>{" "}
                            {maskDataHistoricoSemHora(
                              dataFimConcessao || laudo?.dataFimValidade
                            )}
                          </Text>
                        ) : (
                          <Text
                            fontSize="sm"
                            fontWeight="300"
                            mr={"15px"}
                            mt={5}
                          >
                            <b>Data fim validade:</b> Indeterminado
                          </Text>
                        )}
                        {limite > 0 ? (
                          <Text
                            fontSize="sm"
                            fontWeight="300"
                            mr={"15px"}
                            mt={5}
                          >
                            <b>Quantidade de passagem mensal: </b>
                            {acompanhante ? limite * 2 : limite * 2}
                          </Text>
                        ) : (
                          <Text
                            fontSize="sm"
                            fontWeight="300"
                            mr={"15px"}
                            mt={5}
                          >
                            <b>Quantidade de passagem mensal:</b> Ilimitado
                          </Text>
                        )}
                        {perfisPermitidosLaudo && (
                          <Flex
                            align={"center"}
                            alignItems={"center"}
                            justifyContent={"end"}
                          >
                            <Button
                              variant="solid"
                              colorScheme="blue"
                              width={"30%"}
                              mt={"20px"}
                              fontSize="sm"
                              borderRadius="16px"
                              onClick={handlePrint}
                              leftIcon={<MdPrint size="20px" />}
                              p="25px"
                            >
                              Imprimir laudo
                            </Button>
                          </Flex>
                        )}
                      </Flex>
                    ) : (
                      <Text
                        fontSize="sm"
                        fontWeight="300"
                        mr={"15px"}
                        mt={5}
                        mb={5}
                        color={"red"}
                      >
                        Sem dados de laudo
                      </Text>
                    )}
                    <Flex justify="space-around">
                      <Button
                        variant="light"
                        fontSize="sm"
                        borderRadius="16px"
                        leftIcon={
                          <MdOutlineDoubleArrow
                            size="20px"
                            style={{ rotate: "180deg" }}
                          />
                        }
                        p="25px"
                        onClick={() => rulesTab.current.click()}
                      >
                        Anterior
                      </Button>
                      <Button
                        variant="light"
                        fontSize="sm"
                        borderRadius="16px"
                        ml={"20px"}
                        w={{ base: "128px", md: "148px" }}
                        h="46px"
                        rightIcon={
                          <MdOutlineDoubleArrow
                            size="20px"
                          //style={{ rotate: "180deg" }}
                          />
                        }
                        onClick={() => {
                          mediaTab.current.click();
                        }}
                      >
                        Próximo
                      </Button>
                    </Flex>
                  </Card>
                </TabPanel>
                <TabPanel
                  w={{ sm: "330px", md: "700px", lg: "850px" }}
                  p="0px"
                  mx="auto"
                >
                  <Card p="30px" h={"500px"}>
                    <Text
                      color={textColor}
                      fontSize="2xl"
                      fontWeight="700"
                      mb="20px"
                    >
                      Foto biométrica{" "}
                    </Text>
                    {/* <Profile
                      dataUser={dataUser}
                      handleFotoIndex={handleFotoIndex}
                      cpfBusca={cpfSearch}
                      protocolo={protocolo}
                    /> */}
                    {algumUsuarioCompativel ? (
                      <>
                        {isentoBiometria ? (
                          <>
                            <Flex direction="column" w="100%" align={"center"}>
                              <Text
                                color={textColor}
                                fontSize="md"
                                fontWeight="700"
                                mb="20px"
                              >
                                Usuário isento de biometria
                              </Text>
                              {biometria && (
                                <Text
                                  color={textColor}
                                  fontSize="sm"
                                  fontWeight="700"
                                >
                                  Motivo: Biometria desativada
                                </Text>
                              )}
                              {menor12Anos(dataRec) === true && (
                                <Text
                                  color={textColor}
                                  fontSize="sm"
                                  fontWeight="700"
                                >
                                  Motivo: Idade inferior a 8 anos
                                </Text>
                              )}
                            </Flex>
                            <Flex justify="space-around" mt={275}>
                              <Button
                                variant="light"
                                fontSize="sm"
                                borderRadius="16px"
                                leftIcon={
                                  <MdOutlineDoubleArrow
                                    size="20px"
                                    style={{ rotate: "180deg" }}
                                  />
                                }
                                p="25px"
                                onClick={() => regrasTab.current.click()}
                              >
                                Anterior
                              </Button>
                              <Button
                                variant="light"
                                fontSize="sm"
                                borderRadius="16px"
                                ml={"20px"}
                                w={{ base: "128px", md: "148px" }}
                                h="46px"
                                rightIcon={
                                  <MdOutlineDoubleArrow
                                    size="20px"
                                  //style={{ rotate: "180deg" }}
                                  />
                                }
                                onClick={() => {
                                  cartaoTab.current.click();
                                }}
                              >
                                Próximo
                              </Button>
                            </Flex>
                          </>
                        ) : (
                          <>
                            <Flex direction="column" w="100%">
                              <SimpleGrid
                                columns={{ base: 12, md: 1 }}
                                gap="0px"
                                mb="130px"
                              >
                                <Stack direction="column" gap="20px">
                                  <Camera
                                    tipoGratuidade={3}
                                    dataUser={dataUser}
                                    handleFoto={handleFoto}
                                    cpfBusca={cpfSearch || numeroCns}
                                    nomeUser={nomeCompleto}
                                    dtNascimento={dataRec}
                                    cep={cep}
                                    tipoDocumento={
                                      cpfSearch ? "CPF" : "MATRICULA"
                                    }
                                  ></Camera>
                                </Stack>
                              </SimpleGrid>
                              <Divider mb="20px" mt="110px" />
                            </Flex>
                            <Flex justify="space-around">
                              <Button
                                variant="light"
                                fontSize="sm"
                                borderRadius="16px"
                                leftIcon={
                                  <MdOutlineDoubleArrow
                                    size="20px"
                                    style={{ rotate: "180deg" }}
                                  />
                                }
                                p="25px"
                                onClick={() => regrasTab.current.click()}
                              >
                                Anterior
                              </Button>

                              <Button
                                variant="light"
                                fontSize="sm"
                                borderRadius="16px"
                                ml={"20px"}
                                disabled={!image ? true : false}
                                w={{ base: "128px", md: "148px" }}
                                h="46px"
                                isLoading={loading}
                                loadingText="Salvando..."
                                rightIcon={
                                  <MdOutlineDoubleArrow
                                    size="20px"
                                  //style={{ rotate: "180deg" }}
                                  />
                                }
                                onClick={() => {
                                  nextPageMedia();

                                  cartaoTab.current.click();
                                  setActiveBullets({
                                    form: true,
                                    rules: true,
                                    regras: true,
                                    media: true,
                                    cartao: true,
                                    validation: false,
                                  });
                                  setAlterarBiometriaFacial(
                                    !alterarBiometriaFacial
                                  );

                                  //cartaoTab.current.click();
                                }}
                              >
                                Próximo
                              </Button>
                            </Flex>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <Flex
                          direction="column"
                          w="100%"
                          justifyContent={"center"}
                          align={"center"}
                        >
                          <Text
                            color={"green.300"}
                            fontSize="2xl"
                            mt={"7px"}
                            align={"center"}
                            fontWeight="700"
                            mb="20px"
                          >
                            {handleFotoAlterada || image
                              ? "Foto tirada pelo usuário no app Jaé ou pelo atendente de loja!"
                              : "Perfil não autorizado a tirar foto biométrica!"}
                          </Text>
                          <Avatar
                            src={`data:image/jpeg;base64,${handleFotoAlterada
                              ? handleFotoAlterada.replace(
                                "data:image/jpeg;base64,",
                                ""
                              )
                              : image.replace("data:image/jpeg;base64,", "")
                              }`}
                            h="237px"
                            w="237px"
                            me="20px"
                          ></Avatar>
                        </Flex>
                        <Flex justify="end" mt="14px">
                          <Button
                            variant="light"
                            fontSize="sm"
                            borderRadius="16px"
                            w={{ base: "128px", md: "148px" }}
                            h="46px"
                            rightIcon={
                              <MdOutlineDoubleArrow
                                size="20px"
                              //style={{ rotate: "180deg" }}
                              />
                            }
                            onClick={() => {
                              cartaoTab.current.click();
                              setActiveBullets({
                                form: true,
                                rules: true,
                                regras: true,
                                media: true,
                                cartao: true,
                                validation: false,
                              });
                            }}
                          >
                            Próximo
                          </Button>
                        </Flex>
                      </>
                    )}
                  </Card>
                </TabPanel>
                <TabPanel
                  w={{ sm: "330px", md: "700px", lg: "850px" }}
                  p="0px"
                  mx="auto"
                >
                  {algumUsuarioCompativelCartao ? (
                    <Card p="30px">
                      {/* se pedido não existe e (foto não está vazia ou biometria está desativada ) */}
                      {existePedido === false && idLaudo ? (
                        //tipoPedidoCartao !== "PODE SOLICITAR SEGUNDA_VIA"
                        (isentoBiometria === false && !IsEmpty(image)) ||
                          isentoBiometria === true ||
                          biometria === true ? (
                          <Grid
                            flexDirection="column"
                            pt={{ base: "30px", md: "80px", xl: "0px" }}
                          >
                            <Flex direction="column" w="100%">
                              <Text
                                color={textColor}
                                fontSize="2xl"
                                fontWeight="700"
                                mb="20px"
                              >
                                Pedir cartão
                              </Text>
                            </Flex>

                            <Flex alignItems="center" mb="20px">
                              <Text
                                color={textColorSecondary}
                                fontSize="md"
                                fontWeight="700"
                              >
                                Onde o cliente deseja receber o cartão ?{" "}
                              </Text>
                            </Flex>

                            <Flex justify="flex-start">
                              <RadioGroup
                                onChange={(e) => setOndeReceber(e)}
                                defaultValue={"loja"}
                                defaultChecked={true}
                                value={ondeReceber}
                              >
                                <Flex justify="space-around">
                                  <div style={{ marginRight: 20 }}>
                                    <Radio value="loja">Retirada na loja</Radio>

                                    <Icon
                                      ml={"10px"}
                                      as={MdStore}
                                      color={iconColor}
                                      w="24px"
                                      h="24px"
                                    />
                                  </div>
                                  <div>
                                    {/* <Radio value="casa">Receber em casa</Radio>

                                <Icon
                                  as={MdHome}
                                  color={iconColor}
                                  w="24px"
                                  h="24px"
                                /> */}
                                  </div>
                                </Flex>
                              </RadioGroup>
                            </Flex>
                            {ondeReceber === "loja" && (
                              <>
                                <div>
                                  <Text
                                    fontSize="sm"
                                    fontWeight="300"
                                    color={textColor}
                                    mt={"20px"}
                                  >
                                    Lista de lojas:
                                  </Text>
                                </div>

                                <Select
                                  isRequired={true}
                                  id="lojas"
                                  name="lojasApi"
                                  h="44px"
                                  fontSize="sm"
                                  fontWeight="500"
                                  borderRadius="16px"
                                  value={lojaSelecionada} // Certifique-se que 'lojaSelecionada' seja "" inicialmente
                                  onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    if (e.target.value !== "0") {
                                      setLojaSelecionada(selectedValue);
                                      const nrSeqLoja = listaDeLojas.filter(
                                        (loja) => {
                                          if (
                                            loja.codigo ===
                                            parseInt(selectedValue)
                                          ) {
                                            return loja.enderecos[0]
                                              ?.nrSeqEndereco;
                                          }
                                        }
                                      );
                                      setCodigoLojaSelecionada(
                                        nrSeqLoja[0].enderecos[0]?.nrSeqEndereco
                                      );
                                    }
                                  }}
                                >
                                  <option value="0">Selecione a loja</option>
                                  {listaDeLojas
                                    .filter((item) => item.codigo !== 733)
                                    .map((option) => (
                                      <option
                                        key={option.codigo}
                                        value={option.codigo}
                                      >
                                        {option.nome}
                                      </option>
                                    ))}
                                </Select>
                                <div style={{ marginTop: 20 }}>
                                  <Text
                                    fontSize="sm"
                                    fontWeight="600"
                                    color={textColor}
                                    mt={"20px"}
                                  >
                                    Endereço da loja:
                                  </Text>
                                  {listaDeLojas &&
                                    listaDeLojas.filter(
                                      (loja) => loja.codigo == lojaSelecionada
                                    )[0]?.enderecos[0]?.logradouro +
                                    " , " +
                                    listaDeLojas.filter(
                                      (loja) => loja.codigo == lojaSelecionada
                                    )[0]?.enderecos[0]?.numero +
                                    " - " +
                                    listaDeLojas.filter(
                                      (loja) => loja.codigo == lojaSelecionada
                                    )[0]?.enderecos[0]?.complemento}
                                </div>
                              </>
                            )}
                            <div>
                              <Text
                                fontSize="sm"
                                fontWeight="300"
                                color={textColor}
                                mt={"20px"}
                              >
                                {ondeReceber === "loja"
                                  ? "A retirada do cartão na loja não possui taxa de entrega e o prazo de entrega é de até 10 dias úteis."
                                  : "A entrega do cartão no endereço possui taxa de entrega de " +
                                  formatCurrencyFloor(14.0) +
                                  " e o prazo de recebimento é de até 15 dias úteis, após o pagamento do boleto."}
                              </Text>
                            </div>
                            <Flex justify="space-between" mt="24px">
                              <Button
                                variant="light"
                                fontSize="sm"
                                borderRadius="16px"
                                w={{ base: "128px", md: "148px" }}
                                h="46px"
                                leftIcon={
                                  <MdOutlineDoubleArrow
                                    size="20px"
                                    style={{ rotate: "180deg" }}
                                  />
                                }
                                onClick={() => mediaTab.current.click()}
                              >
                                Anterior
                              </Button>

                              <Button
                                variant="light"
                                fontSize="sm"
                                borderRadius="16px"
                                w={{ base: "128px", md: "148px" }}
                                // isDisabled={
                                //   isentoBiometria || laudoStatus ? false : true
                                // }
                                rightIcon={<MdOutlineDoubleArrow size="20px" />}
                                onClick={() => {
                                  handlePedido();
                                }}
                              >
                                Pedir cartão
                              </Button>
                            </Flex>
                          </Grid>
                        ) : (
                          <Flex direction="column" w="100%" align={"center"}>
                            <Text
                              color={textColor}
                              fontSize="2X1"
                              fontWeight="700"
                            >
                              Usuário ainda não possui foto biométrica!{" "}
                            </Text>
                          </Flex>
                        )
                      ) : (
                        <Grid
                          flexDirection="column"
                          pt={{ base: "30px", md: "80px", xl: "0px" }}
                        >
                          <Flex direction="column" w="100%" align={"center"}>
                            {laudoStatus === false && (
                              <Text
                                color={textColor}
                                fontSize="2X1"
                                fontWeight="700"
                              >
                                Usuário ainda não possui laudo cadastrado!
                              </Text>
                            )}
                            {existePedido && (
                              <Text
                                color={textColor}
                                fontSize="2X1"
                                fontWeight="700"
                              >
                                Usuário já possui pedido de cartão!
                              </Text>
                            )}

                            {tipoPedidoCartao ===
                              "PODE SOLICITAR SEGUNDA_VIA" && (
                                <Text
                                  color={textColor}
                                  fontSize="2X1"
                                  fontWeight="700"
                                >
                                  Gratuidade não permite solicitar 2º via,
                                  solicite pelo menu Cliente!
                                </Text>
                              )}

                            {IsEmpty(image) && !biometria && (
                              <Text
                                color={textColor}
                                fontSize="2X1"
                                fontWeight="700"
                              >
                                Usuário ainda não possui foto biométrica!
                              </Text>
                            )}
                          </Flex>
                        </Grid>
                      )}
                    </Card>
                  ) : (
                    <Card p="30px">
                      <Flex direction="column" w="100%" align={"center"}>
                        <Text
                          color={textColor}
                          fontSize="large"
                          fontWeight="700"
                        >
                          O paciente deve acessar o app para captura de foto ou
                          entrar em contato com a Central de Atendimento Jaé,
                          através do 0800 2121 828, para agendar o
                          comparecimento no Posto de Atendimento Jaé.
                        </Text>
                      </Flex>
                      <Flex justify="end" mt="24px">
                        <Button
                          variant="light"
                          fontSize="sm"
                          borderRadius="16px"
                          w={{ base: "128px", md: "148px" }}
                          //h="46px"

                          rightIcon={
                            <MdOutlineDoubleArrow
                              size="20px"
                            //style={{ rotate: "180deg" }}
                            />
                          }
                          onClick={() => {
                            validationTab.current.click();
                          }}
                        >
                          Próximo
                        </Button>
                      </Flex>
                    </Card>
                  )}
                </TabPanel>
                <TabPanel
                  w={{ sm: "330px", md: "700px", lg: "850px" }}
                  p="0px"
                  mx="auto"
                >
                  <Card p="30px">
                    <Grid
                      flexDirection="column"
                      pt={{ base: "30px", md: "80px", xl: "0px" }}
                    >
                      <Flex direction="column" w="100%">
                        <Text
                          color={textColor}
                          fontSize="2xl"
                          fontWeight="700"
                          mb="20px"
                        >
                          Validações
                        </Text>
                        <Flex alignItems="center" mb="20px">
                          <Text
                            color={textColorSecondary}
                            fontSize="md"
                            fontWeight="700"
                          >
                            {progressGratuidade()}/3 FINALIZADO&nbsp;&nbsp;
                            <Icon
                              ms="auto"
                              as={MdFlag}
                              color={
                                progressGratuidade() === 3 ? "green.500" : "red"
                              }
                              h="18px"
                              w="18px"
                            />
                          </Text>
                        </Flex>
                        <SimpleGrid
                          columns={5}
                          gap="5px"
                          alignItems="center"
                          mb="20px"
                        >
                          <Flex
                            bg={checkForm ? "green.500" : bgBar}
                            h="8px"
                            borderRadius="36px"
                          />
                          <Flex
                            bg={
                              IsNotEmpty(image) || biometria
                                ? "green.500"
                                : bgBar
                            }
                            h="8px"
                            borderRadius="36px"
                          />
                          <Flex
                            bg={laudoStatus ? "green.500" : bgBar}
                            h="8px"
                            borderRadius="36px"
                          />
                          {/* <Flex
                            bg={IsNotEmpty(operadora) ? "green.500" : bgBar}
                            h="8px"
                            borderRadius="36px"
                          /> */}
                        </SimpleGrid>
                        <Flex mb="15px" align="center">
                          <Box w="30px" me="12px">
                            <CircProgressMini
                              step="1"
                              percentage={checkForm ? 100 : 0}
                            />
                          </Box>
                          <Text
                            color={checkForm ? textColorTertiary : "red.500"}
                            fontWeight="500"
                            fontSize="md"
                            me="5px"
                          >
                            Informações Cadastrais
                          </Text>
                          {checkForm && (
                            <Icon
                              as={MdCheck}
                              h="18px"
                              w="18px"
                              color={"green.500"}
                            />
                          )}
                        </Flex>
                        <Flex mt="10px" mb="25px" align="center">
                          <Box w="30px" me="12px">
                            <CircProgressMini
                              step="2"
                              percentage={
                                IsNotEmpty(image) || biometria ? 100 : 0
                              }
                            />
                          </Box>
                          <Text
                            fontSize="md"
                            color={
                              IsNotEmpty(image) || biometria
                                ? textColorTertiary
                                : "red.500"
                            }
                            fontWeight="300"
                          >
                            Imagem Facial &nbsp;
                            {biometria && "|  Biometria desativada"}
                          </Text>
                          {IsNotEmpty(image) && (
                            <Icon
                              as={MdCheck}
                              h="18px"
                              w="18px"
                              color={"green.500"}
                            />
                          )}
                        </Flex>
                        <Flex mb="25px" align="center">
                          <Box w="30px" me="12px">
                            <CircProgressMini
                              step="3"
                              percentage={laudoStatus === true ? 100 : 0}
                            />
                          </Box>
                          <Text
                            color={
                              laudoStatus === true
                                ? textColorTertiary
                                : "red.500"
                            }
                            fontWeight="500"
                            fontSize="md"
                            me="5px"
                          >
                            Laudo
                          </Text>

                          {laudoStatus && (
                            <Icon
                              as={MdCheck}
                              h="18px"
                              w="18px"
                              color={"green.500"}
                            />
                          )}
                        </Flex>
                        {/* <Flex mb="25px" align="center">
                          <Box w="30px" me="12px">
                            <CircProgressMini
                              step="4"
                              percentage={IsNotEmpty(operadora) ? 100 : 0}
                            />
                          </Box>
                          <Text
                            color={
                              IsNotEmpty(operadora)
                                ? textColorTertiary
                                : "red.500"
                            }
                            fontWeight="500"
                            fontSize="md"
                            me="5px">
                            Regras de Uso
                          </Text>
                          <Text
                            fontSize="md"
                            color={textColorSecondary}
                            fontWeight="300">
                            | Operadoras &nbsp;
                          </Text>
                          {IsNotEmpty(operadora) && (
                            <Icon
                              as={MdCheck}
                              h="18px"
                              w="18px"
                              color={"green.500"}
                            />
                          )}
                        </Flex> */}
                      </Flex>
                      {statusAtual === 3 ? (
                        <OrderStatus
                          ms={{ base: "0px", lg: "20px" }}
                          mt={{ base: "0px", lg: "0px" }}
                          zIndex="0"
                          p="0 20px"
                          gridArea={{
                            base: "2 / 1 / 3 / 3",
                            lg: "1 / 2 / 2 / 3",
                          }}
                          statusData={historicoStatus}
                          dataCadastro={dataCadastroUser}
                        />
                      ) : null}
                    </Grid>
                    <Divider mb="20px" mt="25px" />
                    <Flex direction="column" w="100%" color={textColorTertiary}>
                      {/* <HistoricoTickets
                        dataUser={dataUser[0]}
                        ticketUserNovo={ticketGerado}
                      /> */}
                      <TextField
                        id="observacaoChamado"
                        label="Observação do chamado"
                        h="100px"
                        w="100%"
                        maxLength="150"
                        placeholder="Digite detalhes sobre o atendimento do chamado. Max 150 caracteres"
                        value={observacaoChamado}
                        onChange={(e: {
                          target: { value: React.SetStateAction<string> };
                        }) => setObservacaoChamado(e.target.value)}
                      />
                      <Flex
                        direction="column"
                        w="100%"
                        color={textColorTertiary}
                        alignItems={"flex-end"}
                      >
                        {/* <Button
                            ml={"15px"}
                            w={"263px"}
                            colorScheme="brand"
                            mr={1}
                            onClick={encaminharAtendimento}
                            isLoading={loadingEncaminhar}
                            disabled={observacaoChamado === "" ? true : false}
                          >
                            Encaminhar atendimento
                          </Button> */}

                        <Button
                          ml={"240px"}
                          w={"263px"}
                          colorScheme="brand"
                          mr={1}
                          onClick={() => finalizarAtendimento()}
                          isLoading={loading}
                        // disabled={observacaoChamado === "" ? true : false}
                        >
                          Finalizar atendimento
                        </Button>
                      </Flex>
                    </Flex>
                  </Card>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Flex>
        </>
      )}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          alignSelf={"center"}
          bgColor={!IsEmpty(dataUser) ? "white" : "green.600"}
          w={"630px"}
        >
          <ModalHeader>
            {!IsEmpty(dataUser) ? (
              <Text fontSize="xl" color={"black"} fontWeight="bold">
                Deseja iniciar atendimento?
              </Text>
            ) : (
              <Text fontSize="xl" color={"white"} fontWeight="bold">
                Deseja iniciar o cadastro a este novo cliente?
              </Text>
            )}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {!IsEmpty(dataUser) ? (
              <Flex direction={"column"}>
                {cpfSearch ? (
                  <Text fontSize="xl" color={"black"}>
                    <b>Cpf:</b> {maskCpfCnpj(cpfSearch)}
                  </Text>
                ) : null}
                {matricula ? (
                  <Text fontSize="xl" color={"black"}>
                    <b>Matrícula:</b> {matricula}
                  </Text>
                ) : null}
                {numeroCns ? (
                  <Text fontSize="xl" color={"black"}>
                    <b>Nº CNS:</b> {numeroCns}
                  </Text>
                ) : null}

                <Text fontSize="xl" color={"black"}>
                  <b>Nome:</b> {nomeUsuario}
                </Text>
              </Flex>
            ) : (
              <Flex direction={"column"}>
                {cpfSearch ? (
                  <Text fontSize="xl" color={"white"}>
                    <b>Cpf:</b> {cpfSearch}
                  </Text>
                ) : null}

                {matricula ? (
                  <Text fontSize="xl" color={"white"}>
                    <b>Matrícula:</b> {matricula}
                  </Text>
                ) : null}

                {numeroCns ? (
                  <Text fontSize="xl" color={"white"}>
                    <b>Nº CNS:</b> {numeroCns}
                  </Text>
                ) : null}
              </Flex>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="brand"
              mr={3}
              onClick={() => confirmarAtendimento(null)}
            >
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={modalData} onClose={onChangeModalDataClose} size={"sm"}>
        <ModalOverlay />
        <ModalContent alignSelf={"center"}>
          <ModalHeader>Escolha a data</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex justify="flex-start" h={"332px"} w={"623px"}>
              <DateRangePicker
                className="rdrDefinedRangesWrapper "
                onChange={handleSelect}
                moveRangeOnFirstSelection={false}
                months={1}
                showMonthAndYearPickers={false}
                ranges={[selectedDateRange]}
                displayMode="date"
                direction="horizontal"
                locale={pt}
                //singleDatePicker={true}
                dragSelectionEnabled={false}
                showDateDisplay={false}
                headerContent={false}
                scroll={{ enabled: false }}
                showPreview={false}
                dateDisplayFormat="dd MMM, yyyy"
                editableDateInputs={false}
                staticRanges={[]}
                inputRanges={[]}
              />
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button
              leftIcon={<MdSearch />}
              colorScheme="brand"
              mr={3}
              onClick={() => {
                setDataValidade(selectedDateRange.startDate);
                onChangeModalDataClose();
              }}
            >
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal
        isOpen={isOpen3}
        onClose={onChangeModalConfirmacaoAlteracaoLaudoFechar}
      >
        {" "}
        <ModalOverlay />
        <ModalContent alignSelf={"center"} w={"630px"}>
          <ModalHeader>
            <Text fontSize="xl" color={"black"} fontWeight="bold">
              Confirma salvar o laudo e conceder a gratuidade?
            </Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody></ModalBody>
          <ModalFooter>
            <Button
              colorScheme="brand"
              mr={3}
              isLoading={loading}
              loadingText="Salvando..."
              onClick={() => salvarLaudoConcederBeneficio()}
              leftIcon={<MdOutlineEngineering size="20px" />}
            >
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
